<template>
  <div>
    <!-- App Bar -->
    <FrontEndHeader class="pb-2" @signedOut="signedOut"></FrontEndHeader>
    <CounterLoader :message="loaderMessage"></CounterLoader>
    <div class="mt-16">
      <div :style="{ backgroundColor: '#000' }">
        <!-- <vAlertHeader title=" " class="mb-n4"></vAlertHeader> -->
        <v-alert v-if="remainingDocsMessage" type="info" dense text>
          {{ remainingDocsMessage }}
        </v-alert>
        <v-alert v-if="pdfDataUrl" type="success" text>
          PDF generated successfully!
        </v-alert>

        <vAlertHeader
          class="mt-n1 mb-n4"
          :title="selectedDocumentCategory.text"
          color="#000"
        ></vAlertHeader>

        <Loader :message="loaderMessage"></Loader>

        <!-- V-Stepper -->
        <v-stepper v-model="currentStep" vertical>
          <v-stepper-step
            :complete="currentStep > 1"
            step="1"
            :color="currentStep > 1 ? 'success' : 'primary'"
          >
            <h6>Select Document You Want To Generate</h6>
            <small>Simply Click To Select</small>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-row>
              <v-col :cols="6"
                ><v-select
                  label="Filter By Category"
                  :items="documentsCategories"
                  v-model="selectedDocumentCategory"
                  @change="getAndLoadSelectedDocCategory"
                  return-object
                ></v-select
              ></v-col>
              <v-col :cols="6">
                <v-select
                  label="Select Doc Language"
                  :items="languages"
                  v-model="selectedLanguage"
                ></v-select
              ></v-col>
            </v-row>

            <v-radio-group v-model="selectedDocType">
              <v-card class="mb-8">
                <!-- Virtual Scroller For Mobile -->
                <div v-if="isMobile">
                  <v-card flat class="mx-auto">
                    <v-virtual-scroll
                      :bench="0"
                      :items="documentTypes"
                      height="400"
                      item-height="84"
                    >
                      <template v-slot:default="{ item }">
                        <v-list-item :key="item.key">
                          <v-list-item-action>
                            <v-btn fab x-small depressed color="red" dark>
                              <v-icon>mdi-file-pdf</v-icon>
                            </v-btn>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-card-subtitle>
                              <strong>{{ item.label }}</strong>
                            </v-card-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-radio
                              :value="item.key"
                              @click="getSelectedDocTemplateUrl"
                            ></v-radio>
                          </v-list-item-action>
                        </v-list-item>

                        <v-divider></v-divider>
                      </template>
                    </v-virtual-scroll>
                  </v-card>
                </div>
                <!-- End of Virtual Scroller For Mobile -->

                <!-- Cards For Desktop -->
                <div v-else>
                  <v-row>
                    <v-col
                      :cols="3"
                      v-for="(item, ind) in documentTypes"
                      :key="ind"
                    >
                      <!-- <v-card> -->
                      <main
                        class="d-flex flex-wrap gap-4 justify-content-center mb-5 text-center text-white card-box"
                      >
                        <section class="cards p-5 rounded-3 mt-2">
                          <div class="d-block mx-auto rounded-circle mb-3 img">
                            <v-icon color="red" dark class="mt-2"
                              >mdi-file-pdf</v-icon
                            >
                          </div>
                          <span class="name fw-bold d-block">{{
                            item.label
                          }}</span>
                          <!-- <span
                            class="d-block mb-5"
                            v-if="priceCategories[item.priceTier]"
                            >{{ getCurrency
                            }}{{ priceCategories[item.priceTier].price }}</span
                          > -->
                          <button
                            class="mt-3 fw-bold rounded-pill py-2 px-5 bg-transparent"
                          >
                            <v-radio
                              :value="item.key"
                              @click="getSelectedDocTemplateUrl"
                            >
                              <template v-slot:label>
                                <div>
                                  <strong class="brown--text">Select</strong>
                                </div>
                              </template>
                            </v-radio>
                          </button>
                        </section>
                      </main>
                      <!-- <v-card-text>
                        <v-row align="center" class="mx-0">
                          <v-icon color="red" dark>mdi-file-pdf</v-icon>

                          <v-radio
                            :value="item.key"
                            @click="getSelectedDocTemplateUrl"
                          >
                            <template v-slot:label>
                              <div>
                                <strong class="brown--text">{{
                                  item.label
                                }}</strong>
                              </div>
                            </template>
                          </v-radio>
                        </v-row>
                      </v-card-text> -->
                      <!-- </v-card> -->
                    </v-col>
                  </v-row>
                </div>

                <!-- End of Cards For Desktop -->
              </v-card>
            </v-radio-group>
            <v-btn
              color="success"
              @click="
                selectedDocType
                  ? (currentStep = 2)
                  : $toast.error('No Document Selected!')
              "
            >
              Continue
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :complete="currentStep > 2"
            step="2"
            :color="currentStep > 2 ? 'success' : 'primary'"
          >
            <h6>
              {{
                selectedDocObj
                  ? "Details Needed For " + selectedDocObj.label
                  : "Provide Extra Info If Necessary [Optional]"
              }}
            </h6>
            <small>Help the Ai to serve you better.</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-card class="mb-8">
              <!-- Dynamic Form Inputs -->
              <v-form
                ref="form"
                v-model="formValid"
                lazy-validation
                class="mt-4"
              >
                <!-- Your existing dynamic fields for document type -->
                <v-row>
                  <v-col
                    :cols="isMobile ? 12 : 4"
                    v-for="(field, key) in getDocFields[selectedDocType] || {}"
                    :key="key"
                  >
                    <v-textarea
                      :rows="4"
                      v-model="docData[key]"
                      :label="field.label"
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>

                  <!-- <v-col cols="4" v-for="field in lineItemField.fields" :key="field.model">
          <v-text-field
            v-model="item[field.model]"
            :label="field.label"
            :type="field.type === 'number' ? 'number' : 'text'"
            dense
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="1">
          <v-btn icon @click="removeItem(index)" color="red"><v-icon>mdi-delete</v-icon></v-btn>
        </v-col> -->

                  <v-textarea
                    class="mx-4"
                    v-model="extraSpecificRequirement"
                    label="Any Extra Details"
                    outlined
                    :rows="2"
                  ></v-textarea>
                </v-row>

                <!-- Brand Information -->

                <v-expansion-panels v-if="brand">
                  <v-expansion-panel v-for="(item, i) in 1" :key="i">
                    <v-expansion-panel-header
                      color="wheat"
                      style="background-color: #263238; color: wheat"
                    >
                      Brand Your Document [Optional]
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row class="mt-4">
                        <v-col :cols="isMobile ? 12 : 4"
                          ><v-text-field
                            v-model="brand.name"
                            label="Brand Name"
                            :rules="[(v) => !!v || 'Required']"
                            outlined
                            dense
                          ></v-text-field
                        ></v-col>
                        <v-col :cols="isMobile ? 12 : 4"
                          ><v-text-field
                            v-model="brand.phone"
                            label="Brand Contact Number"
                            outlined
                            dense
                          ></v-text-field
                        ></v-col>
                        <v-col :cols="isMobile ? 12 : 4">
                          <v-file-input
                            v-model="brand.logoFile"
                            label="Upload Logo Image"
                            accept="image/*"
                            outlined
                            dense
                            @change="handleLogoUpload"
                          ></v-file-input
                        ></v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            v-model="brand.address"
                            label="Business Address"
                            :rows="1"
                            outlined
                            dense
                          ></v-textarea
                        ></v-col>
                      </v-row>

                      <!-- <v-text-field
                        v-model="brand.logoUrl"
                        label="Logo URL"
                        outlined
                        dense
                        hint="Or upload an image below"
                        persistent-hint
                      ></v-text-field> -->
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-form></v-card
            >
            <v-btn
              color="success"
              @click="
                formValid
                  ? (currentStep = 3)
                  : $toast.info('Its Helpful To Provide Extra Info')
              "
            >
              Continue
            </v-btn>
            <v-btn text @click="currentStep = 1"> Back </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :complete="currentStep > 3"
            step="3"
            :color="currentStep > 3 ? 'success' : 'primary'"
          >
            <h6>Generate Document</h6>
            <small>Click on button to Generate PDF</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card class="mb-8">
              <v-row v-if="isMobile">
                <v-col :cols="6"
                  ><v-btn color="success" @click="generateDocument">
                    Generate Now
                  </v-btn></v-col
                >
                <v-col :cols="6">
                  <v-btn
                    color="purple"
                    :class="isMobile ? ' white--text' : 'ml-2 white--text'"
                    @click="downloadPDF"
                    ><v-icon>mdi-email</v-icon>Email Doc</v-btn
                  ></v-col
                >
                <v-col :cols="6" :class="isMobile ? 'mt-n4' : ''"
                  ><v-btn
                    color="error"
                    :class="isMobile ? 'white--text' : 'ml-2 white--text'"
                    @click="downloadPDF"
                    ><v-icon>mdi-file-pdf</v-icon>Download Doc</v-btn
                  ></v-col
                >
                <v-col :cols="12" :class="isMobile ? 'mt-n6' : ''"
                  ><v-btn
                    v-if="!getPaymentDone"
                    color="primary"
                    :class="
                      isMobile ? 'mt-2 ml-n1 white--text' : 'ml-2 white--text'
                    "
                    @click="removeWatermark"
                    >Remove Watermark</v-btn
                  ></v-col
                >
              </v-row>
              <div v-else>
                <v-btn color="success" @click="generateDocument">
                  Generate Now
                </v-btn>
                <v-btn
                  color="purple"
                  :class="isMobile ? ' white--text' : 'ml-2 white--text'"
                  @click="openEmailDialog()"
                  ><v-icon>mdi-email</v-icon>Email Doc</v-btn
                >
                <v-btn
                  color="error"
                  :class="isMobile ? 'white--text' : 'ml-2 white--text'"
                  @click="downloadPDF"
                  ><v-icon>mdi-file-pdf</v-icon>Download Doc</v-btn
                >
                <v-btn
                  v-if="!getPaymentDone"
                  color="primary"
                  :class="
                    isMobile ? 'mt-2 ml-n1 white--text' : 'ml-2 white--text'
                  "
                  @click="removeWatermark"
                  >Remove Watermark</v-btn
                >
              </div>

              <!-- v-if="pdfContent || pdfDataUrl" -->

              <!-- <v-btn
                color="primary"
                @click="removeWatermark"
                v-if="docGenerated && !getPaymentDone"
              >
                Remove WATERMARK
              </v-btn> -->
              <v-btn
                text
                @click="currentStep = 2"
                :class="isMobile ? 'my-2' : 'my-2'"
              >
                Back
              </v-btn>
              <v-btn
                text
                @click="createNewDoc()"
                :class="isMobile ? 'ml-2 my-2' : 'ml-2 my-2'"
              >
                CREATE NEW DOC
              </v-btn>

              <div v-if="isMobile">
                <div>
                  <v-card>
                    <v-card-text>
                      <div v-if="pdfReady" class="controls my-4">
                        <v-btn @click="prevPage" :disabled="currentPage <= 1"
                          >Prev</v-btn
                        >
                        <span class="mx-2"
                          >Page {{ currentPage }} / {{ totalPages }}</span
                        >
                        <v-btn
                          @click="nextPage"
                          :disabled="currentPage >= totalPages"
                          >Next</v-btn
                        >
                        <div class="mt-2">
                          <v-btn @click="zoomOut" :disabled="zoom <= 0.5"
                            >-</v-btn
                          >
                          <span class="mx-2">Zoom: {{ zoom.toFixed(1) }}</span>
                          <v-btn @click="zoomIn" :disabled="zoom >= 2">+</v-btn>
                        </div>
                        <!-- <v-btn class="ml-4" @click="downloadPDF"
                          >Download</v-btn
                        > -->
                      </div>
                      <!-- <div
                        class="pdf-canvas-wrapper d-flex justify-center"
                        v-if="pdfReady"
                      >
                        <canvas ref="pdfCanvas" class="pdf-canvas"></canvas>
                      </div> -->
                      <div
                        class="pdf-canvas-wrapper d-flex justify-center"
                        v-if="pdfReady"
                      >
                        <canvas ref="pdfCanvas" class="pdf-canvas"></canvas>
                      </div>
                      <iframe
                        v-if="pdfDataUrl && !isLoading"
                        :src="pdfDataUrl"
                        width="100%"
                        height="1200"
                        frameborder="0"
                      ></iframe>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
              <div v-else>
                <iframe
                  :src="pdfBlobUrl"
                  width="100%"
                  height="1200px"
                  frameborder="0"
                ></iframe>
              </div>
            </v-card>
          </v-stepper-content>
        </v-stepper>

        <!-- End of V-Stepper -->
        <!-- <v-card
          flat
          class="pa-4"
          :style="{ backgroundColor: 'white', borderRadius: '12px' }"
        > -->
        <!-- Document Type Selection -->
        <!-- <v-select
            v-model="selectedDocType"
            :items="documentTypes"
            label="Select Document Type"
            item-text="label"
            item-value="key"
            outlined
            class="mt-4"
            @change="getSelectedDocTemplateUrl"
          ></v-select> -->

        <!-- Limits Info -->

        <!-- Payment + Generate Button -->
        <!-- <v-row class="mt-5" align="center">
            <v-col cols="12" md="6">
              <v-btn
                color="teal"
                large
                class="white--text"
                :loading="loading"
                :disabled="!formValid"
                @click="generateDocument"
              >
                Generate Document
              </v-btn>
            </v-col> -->
        <!-- <v-col cols="12" md="6">
              <v-btn-toggle v-model="selectedTier" mandatory>
                <v-btn value="single">R99 / Doc</v-btn>
                <v-btn value="monthly">R199 / Month</v-btn>
                <v-btn value="yearly">R1999 / Year</v-btn>
              </v-btn-toggle>
            </v-col> -->
        <!-- </v-row> -->

        <!-- Payment Options -->
        <!-- <v-row class="mt-4">
            <v-col cols="6">
              <v-btn color="blue" block @click="payWithPayPal"
                >Pay with PayPal</v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn color="green" block @click="payWithPayFast"
                >Pay with PayFast</v-btn
              >
            </v-col>
          </v-row> -->

        <!-- PDF Preview -->
        <!-- <v-card flat class="mt-6 pa-4" v-if="pdfContent">
            <h3 class="subtitle-1 mb-2">Preview</h3>
            <iframe
              :src="pdfBlobUrl"
              width="100%"
              height="1200px"
              frameborder="0"
            ></iframe>
            <v-btn color="teal" class="mt-3 white--text" @click="downloadPDF"
              >Download PDF</v-btn
            >
          </v-card> -->

        <!-- watermark -->
        <!-- <v-card class="pa-4" elevation="2">
          <div style="position: relative">
            
            <div
              v-if="isGuestOrLimited && !getPaymentDone"
              style="
                position: absolute;
                top: 20%;
                left: 10%;
                transform: rotate(-20deg);
                font-size: 3em;
                color: rgba(0, 0, 0, 0.1);
                pointer-events: none;
                z-index: 1;
              "
            >
              WATERMARK - PREVIEW ONLY
            </div>

           
          </div>
        </v-card> -->
        <!-- </v-card> -->
      </div>
      <WebsiteFooter></WebsiteFooter>

      <!-- Show Verification Dialog -->
      <v-dialog
        v-model="showVerificationDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        persistent
      >
        <v-card>
          <FrontEndHeader class="pb-2" @signedOut="signedOut"></FrontEndHeader>
          <center>
            <v-card max-width="600px" class="mt-14 pt-14">
              <vAlertHeader
                title="Enter Verification Code"
                :color="getThemeColor"
              ></vAlertHeader>
              <v-row class="mt-14 pt-14 mx-auto">
                <v-col :cols="12">
                  <v-card-title>
                    Check Your Email For The Verification Code
                  </v-card-title>
                  <v-otp-input
                    length="6"
                    v-model="otp"
                    @finish="verifyUserEmail"
                  ></v-otp-input
                ></v-col> </v-row
            ></v-card>
          </center>
        </v-card>
      </v-dialog>

      <!-- Show Payment Dialog -->
      <v-dialog v-model="showPaymentModal" persistent overlay-opacity="0.8">
        <v-card>
          <v-card-title
            class="headline white--text"
            :style="{ backgroundColor: getThemeColor }"
          >
            Unlock Full Document
          </v-card-title>
          <!-- <v-card-text>
            <p>You're viewing a preview with watermark.</p>
            <p>
              Purchase full access for {{ getCurrency
              }}{{ singlePricePlan.price }}.
            </p>
          </v-card-text> -->

          <PricingTable
            :selectedDocObj="selectedDocObj"
            :pricingPlans="pricingPlans"
            :priceCategories="priceCategories"
          ></PricingTable>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialog" color="red" dark>Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="emailDialog"
        persistent
        overlay-opacity="0.8"
        max-width="750"
      >
        <v-card>
          <v-card-title
            class="headline white--text"
            :style="{ backgroundColor: getThemeColor }"
          >
            <v-icon dark left>mdi-email</v-icon>Send Email With Document As An
            Attachment
          </v-card-title>
          <div class="px-4">
            <v-text-field
              label="Recipients"
              v-model="emailRecipients"
            ></v-text-field>
            <v-text-field
              label="Email Subject"
              v-model="emailSubject"
            ></v-text-field>
            <v-text-field
              label="Recipient Name / Position / Office etc"
              v-model="emailRecipient"
            ></v-text-field>
            <v-btn @click="generateEmailBody" color="warning" dark
              >Generate Email Body With Ai</v-btn
            >
            <div>
              <div id="editorjs" class="mb-2"></div>
            </div>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="sendEmail" color="purple" dark>Send Email</v-btn>
            <v-btn @click="closeDialog" color="red" dark>Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import companyJs from "@/plugins/company";
import helpersJs from "@/plugins/helpers";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

//Editor js libraries
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Table from "@editorjs/table";
import CodeTool from "@editorjs/code";
import Paragraph from "@editorjs/paragraph";
import Parser from "editorjs-parser";

import FrontEndHeader from "@/modules/Auth/FrontEndHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
import * as pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
import Loader from "@/components/Loader";
import vAlertHeader from "@/components/Legos/vAlertHeader";
import PricingTable from "./PricingTable";
import CounterLoader from "./CounterLoader.vue";

export default {
  components: {
    CounterLoader,
    vAlertHeader,
    PricingTable,
    Loader,
    FrontEndHeader,
    WebsiteFooter,
  },
  computed: {
    getCompanyEmis() {
      return this.$store.getters.getCompanyEmis;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getEmailBodyHtml() {
      return this.$store.getters.getEmailBodyHtml;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getPDFContent() {
      return this.$store.getters.getPDFContent;
    },
    getUserIP() {
      return this.$store.getters.getUserIP;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getDocsAiLogObj() {
      return this.$store.getters.getDocsAiLogObj;
    },

    isCreditExpired() {
      return this.$store.getters.isCreditExpired;
    },
    isLimitExceeded() {
      return this.$store.getters.isLimitExceeded;
    },
    remainingDocsMessage() {
      return this.$store.getters.remainingDocsMessage;
    },
    getPaymentDone() {
      return this.$store.getters.getPaymentDone;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    allDocsTypes() {
      return {
        common: [
          {
            key: "affidavit_for_lost_id",
            label: "Affidavit for Lost ID",
            templateUrl: null,
            prompt: `
        Create a sworn affidavit for {{name}} (ID: {{id}}) declaring the loss of ID on {{lossDate}}. Circumstances: {{details}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "business_plan",
            label: "Simple Business Plan",
            templateUrl: null,
            prompt: `
        Create a business plan for {{businessName}} owned by {{ownerName}} in the {{sector}} sector. Goals: {{goals}}. Products: {{products}}. Market: {{market}}. Finances: {{financeSummary}}.
          `,
            priceTier: "tier3",
          },
          {
            key: "business_plan",
            label: "Comprehensive Business Plan",
            templateUrl: null,
            prompt: `
Create a professional and comprehensive business plan for {{businessName}}, owned by {{ownerName}}, operating in the {{sector}} sector. The plan should include the following:

1. Executive Summary – Provide a high-level overview of the business, its mission, and vision.
2. Business Description – Elaborate on the background, business model, and unique value proposition.
3. Business Goals – Describe short-term and long-term goals: {{goals}}.
4. Products and Services – Provide a detailed description of the products/services: {{products}}.
5. Market Analysis – Include a breakdown of the target market: {{market}}, market size, trends, customer demographics, and competitor overview.
6. Marketing and Sales Strategy – Describe go-to-market strategies, pricing model, customer acquisition plans, and distribution channels.
7. Operations Plan – Outline key operations including staffing, logistics, supply chain, and day-to-day activities.
8. Financial Summary – Include a summary of current financial status and revenue streams: {{financeSummary}}.
9. Financial Projections – Provide 3–5 year financial projections including income statement, balance sheet, and cash flow forecasts.
10. Funding Requirements – Detail any capital required, how it will be used, and potential investor benefits.
11. Financial Modelling – Incorporate realistic financial assumptions, break-even analysis, and risk factors.
12. Appendices – Reference any supporting data or charts as needed.

The tone should be formal and investor-ready. All sections should be well-structured, analytical, and professionally presented.
  `,
            priceTier: "tier5",
          },
          {
            key: "travel_consent_for_minor",
            label: "Travel Consent for Minor",
            templateUrl: null,
            prompt: `
        Create a travel consent letter by {{parent}} for their minor child {{child}} to travel to {{destination}} from {{dates}}, accompanied by {{accompanying}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "letter_of_good_standing",
            label: "Letter of Good Standing",
            templateUrl: null,
            prompt: `
        Create a formal request for a letter of good standing by {{name}} (ID/Reg: {{idNumber}}) representing {{company}}. Reason: {{reason}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "freelance_contract",
            label: "Freelance Service Agreement",
            templateUrl: null,
            prompt: `
        Draft a freelance service agreement between {{freelancer}} and {{client}}. Services: {{services}}. Fee: R{{fee}}. Deadline: {{deadline}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "vehicle_sale_agreement",
            label: "Vehicle Sale Agreement",
            templateUrl: null,
            prompt: `
        Generate a vehicle sale agreement between {{sellerName}} and {{buyerName}} for {{vehicleDetails}} (Reg: {{registrationNumber}}) at R{{salePrice}}, dated {{saleDate}}. Include warranties and terms.
          `,
            priceTier: "tier1",
          },
          {
            key: "invoice",
            label: "Quotation + Invoice Template",
            templateUrl:
              "https://www.invoiceberry.com/img/homepage/free_invoice_templates/new/sub_pages/south-africa/screenshot_invoiceberry_invoice_template_5.png",
            priceTier: "tier1",
            prompt: `you are an expert frontend developer, analyse and recreate this document with pdfmake, match the design exactly. for the items in the document, use this information.
            {{services}} for an amount of {{total}}. date is {{dueDate}}.
            1. Header
   - Business name, logo, contact, VAT number

2. Recipient Info
   - Client name, contact details

3. Invoice/Quote Details
   - Document number, issue date, due date

4. Line Items Table
   - Description, Quantity, Unit Price, Total

5. Totals
   - Subtotal
   - Discount (if any)
   - VAT (apply % if applicable)
   - Final Total

6. Payment Instructions
   - Bank name, branch code, account number, reference

7. Footer
   - Thank you note, terms (e.g., “Valid for 7 days”)
- Ensure math is correct
- Use region-appropriate date/currency formats
`,
          },
          {
            key: "acknowledgement_of_debt_one",
            label: "Acknowledgement of Debt",
            templateUrl: null,
            prompt: `
        Generate a formal acknowledgement of debt by {{debtor}} to {{creditor}} for {{amount}}. Payment terms: {{terms}}. Agreement dated: {{date}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "late_payment",
            label: "Late Payment Reminder Letter",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            key: "debt_collection",
            label: "Debt Collection Letter",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            key: "stokvel_membership_agreement",
            label: "Stokvel Membership Agreement",
            templateUrl: null,
            prompt: `
        Write a ${this.countryContext} stokvel membership agreement for {{member}} joining {{stokvel}} with contributions of {{amount}} made {{frequency}}. Agreement date: {{date}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "nda",
            label: "Non-Disclosure Agreement",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            key: "contract",
            label: "General Contract",
            templateUrl: null,
            prompt: `1. Title
   - “Service Agreement”, “Employment Contract”, etc.

2. Parties
   - Full legal names, ID numbers, addresses

3. Definitions & Interpretation
   - Key legal terms defined clearly

4. Terms & Conditions
   - Duration, scope, service expectations

5. Payment Terms
   - Fees, VAT, payment schedule, late penalties

6. Confidentiality & Intellectual Property
   - Who owns what, NDAs, non-disclosures

7. Termination Clause
   - Notice periods, breach, dispute resolution

8. Governing Law
   - “This agreement shall be governed by the laws of South Africa”

9. Signatures
   - Full name, date, place, signature block

10. Annexures
    - Deliverables, timelines, service levels

- Use formal, enforceable phrasing
- Reflect the chosen region (e.g., Western Cape)
`,
            priceTier: "tier1",
          },
          {
            key: "partnership",
            label: "Partnership Agreement",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            key: "lease",
            label: "Lease Agreement (Residential)",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            key: "lease_cancellation_letter",
            label: "Lease Cancellation Letter",
            templateUrl: null,
            prompt: `
        Write a lease cancellation letter from {{tenantName}} to {{landlordName}} regarding {{address}}, effective {{cancelDate}}. Reason: {{reason}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "resignation",
            label: "Resignation Letter",
            templateUrl: null,
            priceTier: "tier1",
          },
          {
            key: "employment",
            label: "Employment Contract",
            templateUrl: null,
            priceTier: "tier1",
          },
          {
            key: "employment_reference_letter",
            label: "Employment Reference Letter",
            templateUrl: null,
            prompt: `
        Create a reference letter from {{employerName}} for {{employeeName}}, who held the position of {{position}} for {{duration}}. Performance: {{performance}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "proof_of_employment_letter",
            label: "Proof of Employment Letter",
            templateUrl: null,
            prompt: `
        Generate a proof of employment letter for {{employeeName}}, employed at {{company}} as a {{position}} since {{startDate}}, earning R{{salary}} per month.
          `,
            priceTier: "tier1",
          },
          {
            key: "termination",
            label: "Termination Letter",
            templateUrl: null,
            priceTier: "tier1",
          },
          {
            key: "leave",
            label: "Leave Approval Letter",
            templateUrl: null,
            priceTier: "tier1",
          },
          {
            key: "warning",
            label: "Warning Letter",
            templateUrl: null,
            priceTier: "tier1",
          },
          {
            key: "consent",
            label: "Medical Consent Form",
            templateUrl: null,
            priceTier: "tier1",
          },
          {
            key: "referral",
            label: "Medical Referral Letter",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            key: "medical_fitness_certificate",
            label: "Medical Fitness Certificate",
            templateUrl: null,
            prompt: `
        Issue a medical certificate by Dr. {{doctor}} for {{patient}}, confirming fitness for {{fitFor}}. Diagnosis: {{diagnosis}}. Date: {{date}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "proof",
            label: "Proof of Consultation Letter",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          { key: "demand", label: "Letter of Demand", templateUrl: null },
          { key: "affidavit", label: "Affidavit Template", templateUrl: null },
          {
            key: "bill_of_costs",
            label: "Attorney Bill of Costs",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            systemPrompt: `You are an expert resume and cover letter writer. You create highly detailed, professional, and well-formatted CVs and cover letters based on minimal input.
            Expand each section to be comprehensive and tailored to general professional roles. Use UK English spelling and formatting.
            You Assume the candidate is highly experienced in the provided industry.
            You assume generic experience and standard responsibilities and tools of the provided industry.
            You Include a strong career summary, detailed experience, relevant skills, and formal education.
            You write a detailed matching cover letter targeted at the provided industry.`,
            key: "cv_and_cover_letter_on_same_pdf_separated_by_page_break",
            label: "CV + Cover Letter",
            templateUrl:
              "https://i.ebayimg.com/images/g/a8YAAOSwcTZoHcEf/s-l1600.webp",
            prompt: `1. Full Name and Contact Info
   - Name, phone, email, LinkedIn, address (optional)

2. Professional Summary
   - 3–5 sentences combining industry experience, key skills, and career goals
   - Tone: confident, industry-specific

3. Key Skills
   - Bullet points, grouped if needed (e.g., “Technical”, “Soft Skills”)

4. Work Experience
   - Job Title, Company, Location, Dates
   - 3–6 bullet points per job describing duties, results, and achievements

5. Education
   - Qualification, Institution, Year
   - Optional: distinctions, subjects, major project

6. Certifications & Courses
   - Relevant short courses, licenses, etc.

7. Projects or Portfolios (if applicable)
   - Especially for IT, creatives, engineers

8. References
   - “Available on request” or list names if provided

- Minimum Length: 2 pages
- CV Summary must be ½ page long
`,
            priceTier: "tier1",
          },
          {
            systemPrompt: `You are an expert resume and cover letter writer. You create highly detailed, professional, and well-formatted CVs and cover letters based on minimal input.
            Expand each section to be comprehensive and tailored to general professional roles. Use UK English spelling and formatting.
            You Assume the candidate is highly experienced in the provided industry.
            You assume generic experience and standard responsibilities and tools of the provided industry.
            You Include a strong career summary, detailed experience, relevant skills, and formal education.
            You write a detailed matching cover letter targeted at the provided industry.`,
            key: "cv_and_cover_letter_on_same_pdf_separated_by_page_break_student",
            label: "Student/Graduate CV + Cover Letter",
            templateUrl:
              "https://i.ebayimg.com/images/g/z-gAAOSwIKxoHl-9/s-l1600.webp",
            prompt: `
Create a polished, entry-level Curriculum Vitae (CV) followed by a persuasive Cover Letter for {{fullName}}, a recent graduate or student. Tailor the documents for roles or internships in the {{industry}} industry.


1. Personal Details – Full name, phone, email, and LinkedIn.
2. Career Objective – A strong paragraph stating career interests and long-term aspirations in {{industry}}.
3. Education – Focused section on {{highestQualification}} and other relevant studies, awards, or courses.
4. Internships / Volunteering / Campus Involvement – Highlight practical exposure or leadership roles (even if informal).
5. Skills – Showcase academic, soft, and digital skills: {{skills}}.
6. Projects / Assignments – Briefly describe academic or personal projects relevant to the field.
7. References – At least two academic or internship references with full names and phone numbers.

Page Break

Page 2 – Cover Letter Includes:
- Addressed to a hiring manager in the {{industry}} sector.
- Highlights eagerness to learn, ability to adapt, and examples of academic or personal success.
- Ends with an enthusiastic request for an opportunity to contribute or interview.
Cover Letter should be made to be lone on the last page of the document. for example if the CV itself is only one page, the cover page should be on page two. all this within the same pdf make document definition for easy rendering
The tone must be positive, growth-oriented, and professional.
  `,
            priceTier: "tier2",
          },
          {
            systemPrompt: `You are an expert resume and cover letter writer. You create highly detailed, professional, and well-formatted CVs and cover letters based on minimal input.
            Expand each section to be comprehensive and tailored to general professional roles. Use UK English spelling and formatting.
            You Assume the candidate is highly experienced in the provided industry.
            You assume generic experience and standard responsibilities and tools of the provided industry.
            You Include a strong career summary, detailed experience, relevant skills, and formal education.
            You write a detailed matching cover letter targeted at the provided industry.`,
            key: "cv_and_cover_letter_on_same_pdf_separated_by_page_break_normal",
            label: "Creative CV + Cover Letter",
            templateUrl:
              "https://assets.livecareer.co.uk/blobimages/lcintl-lp/luk/luksalp01/images/lethabo-cv1.svg",
            prompt: `
Create a visually descriptive, portfolio-ready Curriculum Vitae (CV) and a uniquely written Cover Letter for {{fullName}}, a creative professional pursuing opportunities in the {{industry}} field.


1. Name & Contact – Full name, email, phone, portfolio link, and social handles.
2. Creative Summary – One-paragraph bio capturing creative philosophy, tone, and vision.
3. Key Skills & Tools – List software (e.g., Adobe Suite, Figma), creative methods, and soft skills: {{skills}}.
4. Projects & Roles – Highlight freelance gigs, exhibitions, campaigns, or agency roles: {{experience}}.
5. Education – Include {{highestQualification}}, creative courses, workshops, or certifications.
6. Awards / Mentions / Published Works (if any).
7. References – Creative directors, clients, or collaborators with phone numbers.

Page Break

Page 2 – Cover Letter Includes:
- A personalized narrative describing passion, inspiration, and alignment with the employer’s brand.
- Specific reference to impactful creative work or collaboration.
- A call-to-action for an interview, portfolio review, or discovery meeting.
Cover Letter should be made to be lone on the last page of the document. for example if the CV itself is only one page, the cover page should be on page two. all this within the same pdf make document definition for easy rendering
The voice should balance professionalism with originality and storytelling.
  `,
            priceTier: "tier1",
          },
          {
            systemPrompt: `You are an expert resume and cover letter writer. You create highly detailed, professional, and well-formatted CVs and cover letters based on minimal input.
            Expand each section to be comprehensive and tailored to general professional roles. Use UK English spelling and formatting.
            You Assume the candidate is highly experienced in the provided industry.
            You assume generic experience and standard responsibilities and tools of the provided industry.
            You Include a strong career summary, detailed experience, relevant skills, and formal education.
            You write a detailed matching cover letter targeted at the provided industry.`,
            key: "cv_and_cover_letter_on_same_pdf_separated_by_page_break_executive",
            label: "Executive CV + Cover Letter",
            templateUrl:
              "https://assets.livecareer.co.uk/blobimages/lcintl-lp/luk/luksalp01/images/lethabo-cv4.svg",
            prompt: `
Craft a distinguished and results-driven Executive Curriculum Vitae (CV) followed by a compelling Cover Letter for {{fullName}} targeting leadership opportunities in the {{industry}} industry.

1. Contact Details – Full name, professional email, phone, LinkedIn.
2. Executive Summary – 2–3 paragraphs summarizing strategic experience and leadership style.
3. Professional Experience – Chronological achievements with KPIs, budgets handled, teams led, and successful transformations: {{experience}}.
4. Key Competencies – Leadership, negotiation, strategy, and industry-specific expertise: {{skills}}.
5. Education & Certifications – Include {{highestQualification}}, MBAs, CPDs, and board-level affiliations.
6. Board Memberships / Speaking Engagements / Publications (if applicable).
7. References – High-level professional references with names and phone numbers.

Page Break

Page 2 – Cover Letter Includes:
- Strategically crafted letter addressing a high-level hiring executive.
- Emphasizes change leadership, vision, and business impact.
- Invites discussion on organizational growth and long-term alignment.

The language should reflect confidence, expertise, and executive professionalism.
  `,
            priceTier: "tier3",
          },
          { key: "loan", label: "Personal Loan Agreement", templateUrl: null },
          {
            key: "power_of_attorney",
            label: "Power of Attorney",
            templateUrl: null,
            prompt: `
Create a ${this.countryContext} Power of Attorney where {{principalName}} (ID: {{idNumber}}) appoints {{appointeeName}} for {{authorityPurpose}}. Effective from {{effectiveDate}}. Format as a legal declaration.
  `,
            priceTier: "tier2",
          },
          {
            key: "lesson_plan",
            label: "SA Educator’s Lesson Plan",
            templateUrl: null,
            prompt: null,
            priceTier: "tier1",
          },
          {
            key: "school_transfer_letter",
            label: "School Transfer Letter",
            templateUrl: null,
            prompt: `
Write a formal school transfer letter by {{parentName}} for {{learnerName}}, moving from {{currentSchool}} to {{newSchool}}. Reason: {{transferReason}}. Addressed to the principal.
  `,
            priceTier: "tier1",
          },
          {
            key: "educational_tutor_agreement",
            label: "Educational Tutor Agreement",
            templateUrl: null,
            prompt: `
        Create a tutor agreement between {{tutor}} and {{student}} for {{subject}}. Sessions: {{frequency}}. Hourly rate: R{{rate}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "internship_confirmation_letter",
            label: "Internship Confirmation Letter",
            templateUrl: null,
            prompt: `
        Confirm {{intern}} has an internship at {{company}}, Department: {{department}}, from {{startDate}} to {{endDate}} as a {{role}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "sworn_affidavit_for_SASSA",
            label: "Sworn Affidavit for SASSA",
            templateUrl: null,
            prompt: `
        Generate a SASSA-compatible affidavit for {{applicantName}} (ID: {{idNumber}}), applying for a {{grantType}}. Reason: {{reason}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "notice_of_disciplinary_hearing",
            label: "Notice of Disciplinary Hearing",
            templateUrl: null,
            prompt: `
        Draft a formal notice of disciplinary hearing to {{employee}} from {{employer}}. Allegation: {{allegation}}. Hearing Date: {{hearingDate}}, Location: {{location}}.
          `,
            priceTier: "tier1",
          },
          {
            key: "cohabitation_agreement",
            label: "Cohabitation Agreement",
            templateUrl: null,
            prompt: `
        Generate a cohabitation agreement between {{partner1}} and {{partner2}} living at {{address}}. Financial terms: {{financialTerms}}. Effective: {{date}}.
          `,
            priceTier: "tier1",
          },
        ],
        legal: [
          {
            key: "acknowledgement_of_debt",
            label: "Acknowledgement of Debt Detailed",
            templateUrl: null,
            prompt: `
Create a formal Acknowledgement of Debt where {{debtorName}} (ID: {{debtorId}}) acknowledges owing R{{amount}} to {{creditorName}} (ID: {{creditorId}}), to be repaid under these terms: {{terms}} by {{dueDate}} with an interest rate of {{interestRate}}%. This document is governed by the laws of {{governingLaw}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "general_affidavit",
            label: "Affidavit – General",
            templateUrl: null,
            prompt: `
Create a general affidavit for {{name}} (ID: {{id}}), residing at {{address}}. The affidavit declares the following facts: {{statement}}. Signed on {{date}}, before Commissioner of Oaths {{commissioner}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "general_power_of_attorney",
            label: "Power of Attorney – General",
            templateUrl: null,
            prompt: `
Draft a general power of attorney document authorizing {{agentName}} (ID: {{agentId}}) to act on behalf of {{principalName}} (ID: {{principalId}}) for the following powers: {{powers}}. Effective from {{startDate}} to {{endDate}} in {{jurisdiction}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "vehicle_sale_power_of_attorney",
            label: "Power of Attorney – Vehicle Sale",
            templateUrl: null,
            prompt: `
Create a vehicle-specific power of attorney for {{agentName}} to sell the vehicle {{vehicleDetails}} with registration number {{regNumber}} and VIN {{vin}}, on behalf of {{principalName}}, starting {{startDate}} and expiring {{endDate}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "loan_agreement",
            label: "Loan Agreement",
            templateUrl: null,
            prompt: `
Generate a loan agreement between lender {{lenderName}} and borrower {{borrowerName}} for R{{amount}} with {{interestRate}}% interest. Repayment terms: {{repaymentTerms}} starting on {{startDate}}. Default consequences: {{defaultClause}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "residential_lease_agreement",
            label: "Lease Agreement – Residential",
            templateUrl: null,
            prompt: `
Draft a residential lease agreement between landlord {{landlordName}} and tenant {{tenantName}} for the property at {{propertyAddress}}. Lease starts on {{startDate}} and ends on {{endDate}}. Monthly rent: R{{monthlyRent}}, deposit: R{{deposit}}, notice period: {{noticePeriod}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "commercial_lease_agreement",
            label: "Lease Agreement – Commercial",
            templateUrl: null,
            prompt: `
Create a commercial lease agreement for {{tenantName}} of {{businessName}} and landlord {{landlordName}} for {{propertyDescription}}. Monthly rent is R{{rentalAmount}}, lease runs from {{startDate}} to {{endDate}}. Utilities included: {{utilities}}, maintenance by: {{maintenance}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "employment_contract_basic",
            label: "Employment Contract – Basic",
            templateUrl: null,
            prompt: `
Generate a basic employment contract for {{employeeName}} hired by {{employerName}} as a {{jobTitle}} starting on {{startDate}}. Work hours: {{workHours}}, salary: R{{salary}}, leave days: {{leaveDays}}, notice period: {{noticePeriod}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "resignation_letter",
            label: "Resignation Letter",
            templateUrl: null,
            prompt: `
Draft a resignation letter for {{employeeName}}, employed as {{jobTitle}} at {{employerName}}, dated {{date}}, with last working day on {{lastDay}}. Reason: {{reason}}. Express gratitude: {{gratitude}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "notice_to_vacate",
            label: "Notice to Vacate",
            templateUrl: null,
            prompt: `
Generate a formal notice to vacate from {{tenantName}} to {{landlordName}} for the property located at {{propertyAddress}}. Date of notice: {{noticeDate}}, intended vacate date: {{vacateDate}}, reason: {{reason}}, forwarding address: {{forwardingAddress}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "cease_and_desist_letter",
            label: "Cease and Desist Letter",
            templateUrl: null,
            prompt: `
Create a cease and desist letter from {{senderName}} to {{recipientName}} regarding the following issue: {{infringement}}. Demand to stop: {{demand}}. Legal consequences: {{consequences}}. Dated: {{date}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "nda_agreement",
            label: "Non-Disclosure Agreement (NDA)",
            templateUrl: null,
            prompt: `
Draft an NDA between {{discloser}} and {{recipient}} regarding {{confidentialInfo}}. Obligations: {{obligations}}. Duration: {{duration}}. Jurisdiction: {{jurisdiction}}. Effective date: {{date}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "sale_of_goods_agreement",
            label: "Sale of Goods Agreement",
            templateUrl: null,
            prompt: `
Create a sale of goods agreement between {{sellerName}} and {{buyerName}} for {{goodsDescription}} ({{quantity}} units at R{{pricePerUnit}} each). Total: R{{totalPrice}}. Delivery: {{deliveryTerms}}, Payment: {{paymentTerms}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "service_agreement",
            label: "Service Agreement",
            templateUrl: null,
            prompt: `
Draft a service agreement between {{providerName}} and {{clientName}} for services: {{services}}. Start: {{startDate}}, End: {{endDate}}, Fees: R{{fees}}, Payment schedule: {{paymentSchedule}}, Termination: {{terminationClause}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "complaint_letter_to_landlord",
            label: "Complaint Letter to Landlord",
            templateUrl: null,
            prompt: `
Create a complaint letter by {{tenantName}} to landlord {{landlordName}} regarding the property at {{propertyAddress}}. Issue: {{issue}}. Requested action: {{action}}. Complaint date: {{complaintDate}}, Response deadline: {{responseDeadline}}.
    `,
            priceTier: "tier1",
          },
        ],
        tender: [
          {
            key: "tender_cover_letter",
            label: "Tender Cover Letter",
            templateUrl: null,
            prompt: `
Write a professional cover letter for tender submission by {{companyName}} for project titled "{{projectTitle}}" with reference number {{referenceNumber}}, submitted on {{submissionDate}}.
1. Cover Page
   - Project name, tender number, submitting company

2. Executive Summary
   - Brief intro and commitment

3. Company Profile
   - History, experience, BEE status, registration

4. Technical Proposal
   - How you’ll deliver on the tender's requirements

5. Pricing Schedule
   - Table with breakdown and totals

6. Compliance Documents
   - Tax, CSD, BEE, director IDs, SARS pin, etc.

7. Contact Details
   - Single point of contact with phone/email

8. Attachments
   - CVs, references, samples, certificates
   - Structure follows standard RFQ/RFP layout
   - Document must be clean and well-formatted

    `,
            priceTier: "tier1",
          },
          {
            key: "tender_bid_proposal",
            label: "Tender Bid Proposal",
            templateUrl: null,
            prompt: `
Generate a bid proposal for {{companyName}} regarding the tender "{{projectTitle}}" (Ref: {{referenceNumber}}). Include services offered, pricing summary, and timelines.
    `,
            priceTier: "tier1",
          },
          {
            key: "company_profile_tender",
            label: "Company Profile for Tender",
            templateUrl: null,
            prompt: `
Create a concise company profile for {{companyName}} highlighting experience, certifications, and capability in delivering {{industryType}} projects.
    `,
            priceTier: "tier1",
          },
          {
            key: "declaration_of_interest",
            label: "Declaration of Interest",
            templateUrl: null,
            prompt: `
Generate a Declaration of Interest form for {{companyName}} and its directors regarding tender {{referenceNumber}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "bank_letter_tender",
            label: "Bank Letter for Tender",
            templateUrl: null,
            prompt: `
Generate a bank confirmation letter template for {{companyName}}, indicating financial capability to execute project "{{projectTitle}}".
    `,
            priceTier: "tier1",
          },
          {
            key: "subcontractor_agreement",
            label: "Subcontractor Agreement",
            templateUrl: null,
            prompt: `
Create an agreement between {{mainContractor}} and {{subcontractor}} for project "{{projectTitle}}" with deliverables and payment terms.
    `,
            priceTier: "tier1",
          },
          {
            key: "nda_tender",
            label: "Tender Non-Disclosure Agreement (NDA)",
            templateUrl: null,
            prompt: `
Draft a non-disclosure agreement between {{companyName}} and {{partnerName}} for sharing confidential info related to project "{{projectTitle}}".
    `,
            priceTier: "tier1",
          },
        ],
        construction: [
          // ==============================
          // Construction and Quantity Surveying
          // ==============================
          {
            key: "bill_of_quantities",
            label: "Bill of Quantities",
            templateUrl: null,
            prompt: `
Generate a bill of quantities for {{projectName}}, prepared by {{companyName}}, including item descriptions, unit costs, quantities, and total amounts.
    `,
            priceTier: "tier1",
          },
          {
            key: "site_inspection_report",
            label: "Site Inspection Report",
            templateUrl: null,
            prompt: `
Create a site inspection report for {{projectName}} inspected on {{inspectionDate}} by {{inspectorName}}. Include observations and recommendations.
    `,
            priceTier: "tier1",
          },
          {
            key: "variation_order_request",
            label: "Variation Order Request",
            templateUrl: null,
            prompt: `
Draft a variation order request for {{projectName}} detailing the changes required, reasons, and impact on cost and timeline.
    `,
            priceTier: "tier1",
          },
          {
            key: "project_completion_certificate",
            label: "Project Completion Certificate",
            templateUrl: null,
            prompt: `
Create a certificate of completion for project "{{projectName}}" completed on {{completionDate}} and approved by {{consultantName}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "contractor_performance_report",
            label: "Contractor Performance Report",
            templateUrl: null,
            prompt: `
Generate a contractor performance evaluation for {{contractorName}} on project "{{projectName}}", rating quality, adherence to schedule, and professionalism.
    `,
            priceTier: "tier1",
          },
          {
            key: "progress_payment_certificate",
            label: "Progress Payment Certificate",
            templateUrl: null,
            prompt: `
Create a payment certificate for {{contractorName}} for work completed on {{projectName}} up to {{valuationDate}}, including breakdowns and approvals.
    `,
            priceTier: "tier1",
          },
          {
            key: "construction_contract_agreement",
            label: "Construction Contract Agreement",
            templateUrl: null,
            prompt: `
Draft a standard construction contract between {{clientName}} and {{contractorName}} for project "{{projectName}}", covering scope, deliverables, and terms.
    `,
            priceTier: "tier1",
          },
        ],
        insurance: [
          // ==============================
          // Insurance Company
          // ==============================
          {
            key: "insurance_quote_letter",
            label: "Insurance Quote Letter",
            templateUrl: null,
            prompt: `
Generate an insurance quotation letter for {{clientName}}, detailing policy type {{policyType}}, premium {{premiumAmount}}, and coverage period {{coveragePeriod}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "policy_schedule",
            label: "Policy Schedule",
            templateUrl: null,
            prompt: `
Create an insurance policy schedule for {{clientName}}, listing coverage types, limits, deductibles, and policy start and end dates.
    `,
            priceTier: "tier1",
          },
          {
            key: "claim_form",
            label: "Insurance Claim Form",
            templateUrl: null,
            prompt: `
Draft a claim form for policyholder {{clientName}} with policy number {{policyNumber}}, for incident on {{incidentDate}} involving {{incidentDetails}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "accident_report",
            label: "Accident Report",
            templateUrl: null,
            prompt: `
Generate an accident report for {{clientName}} for an incident on {{incidentDate}}, including event summary, affected parties, and estimated damages.
    `,
            priceTier: "tier1",
          },
          {
            key: "policy_cancellation_letter",
            label: "Policy Cancellation Letter",
            templateUrl: null,
            prompt: `
Write a cancellation letter from {{clientName}} for policy number {{policyNumber}} with cancellation effective from {{cancelDate}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "renewal_notice",
            label: "Renewal Notice",
            templateUrl: null,
            prompt: `
Create a renewal notice for policyholder {{clientName}}, reminding renewal of policy number {{policyNumber}} before {{renewalDate}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "insurance_cover_confirmation",
            label: "Insurance Cover Confirmation",
            templateUrl: null,
            prompt: `
Generate a letter confirming active insurance cover for {{clientName}} under policy number {{policyNumber}} from {{startDate}} to {{endDate}}.
    `,
            priceTier: "tier1",
          },
        ],
        travel: [
          // ==============================
          // Immigration and Visa Applicants
          // ==============================
          {
            key: "proof_of_employment_letter",
            label: "Proof of Employment Letter",
            templateUrl: null,
            prompt: `
Generate a proof of employment letter for {{employeeName}}, employed by {{employerName}} since {{startDate}}, earning {{salary}}, and holding position {{position}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "invitation_letter_for_visa",
            label: "Invitation Letter for Visa",
            templateUrl: null,
            prompt: `
Create a visa invitation letter from {{hostName}}, residing at {{hostAddress}}, inviting {{visitorName}} to visit {{country}} from {{startDate}} to {{endDate}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "bank_statement_summary",
            label: "Bank Statement Summary",
            templateUrl: null,
            prompt: `
Generate a bank account financial summary for {{accountHolder}} showing balances and inflows for visa processing from {{startDate}} to {{endDate}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "affidavit_of_support",
            label: "Affidavit of Support",
            templateUrl: null,
            prompt: `
Draft an affidavit of financial support by {{sponsorName}} declaring responsibility for {{applicantName}} during stay in {{country}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "cover_letter_for_visa",
            label: "Cover Letter for Visa Application",
            templateUrl: null,
            prompt: `
Write a cover letter for visa application by {{applicantName}}, outlining purpose of travel, financial means, and duration of stay.
    `,
            priceTier: "tier1",
          },
          {
            key: "travel_itinerary_visa",
            label: "Travel Itinerary for Visa",
            templateUrl: null,
            prompt: `
Create a detailed travel itinerary for {{applicantName}} from {{departureDate}} to {{returnDate}}, including destinations, accommodation, and planned activities.
    `,
            priceTier: "tier1",
          },
          {
            key: "proof_of_accommodation",
            label: "Proof of Accommodation",
            templateUrl: null,
            prompt: `
Generate a document proving accommodation for {{applicantName}} at {{hotelNameOrAddress}} from {{checkIn}} to {{checkOut}}.
    `,
            priceTier: "tier1",
          },
        ],
        hr: [
          // ==============================
          // Payslip
          // ==============================
          {
            key: "monthly_payslip",
            label: "Monthly Payslip",
            templateUrl: null,
            prompt: `
Generate a payslip for {{employeeName}} for the month of {{month}} {{year}}, showing earnings, deductions, net pay, and employer details.
    `,
            priceTier: "tier1",
          },
          {
            key: "bonus_payslip",
            label: "Bonus Payslip",
            templateUrl: null,
            prompt: `
Create a bonus payslip for {{employeeName}} issued on {{bonusDate}}, indicating bonus amount, tax deductions, and final payout.
    `,
            priceTier: "tier1",
          },
          {
            key: "termination_payslip",
            label: "Termination Payslip",
            templateUrl: null,
            prompt: `
Generate a final payslip for {{employeeName}}, terminated on {{terminationDate}}, including salary, leave days payout, and severance (if any).
    `,
            priceTier: "tier1",
          },
          {
            key: "overtime_payslip",
            label: "Overtime Payslip",
            templateUrl: null,
            prompt: `
Create a payslip for {{employeeName}} including overtime hours {{overtimeHours}} at rate {{overtimeRate}}, in addition to regular salary.
    `,
            priceTier: "tier1",
          },
          {
            key: "salary_advance_slip",
            label: "Salary Advance Slip",
            templateUrl: null,
            prompt: `
Generate a salary advance record for {{employeeName}} for amount {{advanceAmount}} issued on {{advanceDate}}, deductible from salary.
    `,
            priceTier: "tier1",
          },
          {
            key: "commission_payslip",
            label: "Commission Payslip",
            templateUrl: null,
            prompt: `
Create a commission payslip for {{employeeName}} for period {{period}}, showing total sales {{totalSales}} and commission amount {{commissionAmount}}.
    `,
            priceTier: "tier1",
          },
          {
            key: "year_end_summary",
            label: "Year-End Payslip Summary",
            templateUrl: null,
            prompt: `
Generate a year-end salary summary for {{employeeName}} for year {{year}}, including gross earnings, deductions, and net pay.
    `,
            priceTier: "tier1",
          },
        ],
      };
    },
    getDocFields() {
      const fields = {
        // {
        //   title: "Proof of Residence",
        //   fields: [
        //     { label: "Full Name", key: "fullName" },
        //     { label: "ID Number", key: "idNumber" },
        //     { label: "Residential Address", key: "residence" },
        //     { label: "Issuing Authority", key: "issuer" },
        //     { label: "Date of Issue", key: "issueDate" }
        //   ],
        //   prompt: `
        // Generate a proof of residence for {{fullName}} (ID: {{idNumber}}), living at {{residence}}. Issued by {{issuer}} on {{issueDate}}.
        //   `
        // }

        // {
        //   title: "Child Maintenance Agreement",
        //   fields: [
        //     { label: "Mother's Name", key: "mother" },
        //     { label: "Father's Name", key: "father" },
        //     { label: "Child's Name", key: "child" },
        //     { label: "Monthly Maintenance Amount", key: "amount" },
        //     { label: "Payment Start Date", key: "startDate" }
        //   ],
        //   prompt: `
        // Write a child maintenance agreement between {{mother}} and {{father}} for their child {{child}}. Amount: R{{amount}}/month from {{startDate}}.
        //   `
        // }

        // {
        //   title: "Workplace Incident Report",
        //   fields: [
        //     { label: "Employee Name", key: "employeeName" },
        //     { label: "Incident Date", key: "incidentDate" },
        //     { label: "Incident Description", key: "incidentDescription" },
        //     { label: "Location", key: "location" },
        //     { label: "Witnesses", key: "witnesses" }
        //   ],
        //   prompt: `
        // Generate a formal workplace incident report for {{employeeName}}. Date: {{incidentDate}}, at {{location}}. Description: {{incidentDescription}}. Witnesses: {{witnesses}}.
        //   `
        // }

        // {
        //   title: "Security Company Quotation",
        //   fields: [
        //     { label: "Client Name", key: "client" },
        //     { label: "Company Name", key: "company" },
        //     { label: "Services Offered", key: "services" },
        //     { label: "Duration", key: "duration" },
        //     { label: "Total Cost", key: "total" }
        //   ],
        //   prompt: `
        // Create a professional quotation from {{company}} for {{client}}. Services: {{services}} for {{duration}}. Total cost: R{{total}}.
        //   `
        // }

        // {
        //   title: "Church Invitation Letter",
        //   fields: [
        //     { label: "Church Name", key: "church" },
        //     { label: "Event Name", key: "event" },
        //     { label: "Date of Event", key: "eventDate" },
        //     { label: "Recipient Name", key: "recipient" },
        //     { label: "Location", key: "location" }
        //   ],
        //   prompt: `
        // Compose a formal invitation letter from {{church}} to {{recipient}} for {{event}} on {{eventDate}} at {{location}}.
        //   `
        // }

        // {
        //   title: "Tenant Reference Letter",
        //   fields: [
        //     { label: "Landlord Name", key: "landlord" },
        //     { label: "Tenant Name", key: "tenant" },
        //     { label: "Rental Property", key: "property" },
        //     { label: "Rental Period", key: "rentalPeriod" },
        //     { label: "Tenant Behavior", key: "behavior" }
        //   ],
        //   prompt: `
        // Generate a reference letter by {{landlord}} for tenant {{tenant}} regarding the property at {{property}}, rented from {{rentalPeriod}}. Notes on behavior: {{behavior}}.
        //   `
        // }

        // {
        //   title: "Community Service Confirmation",
        //   fields: [
        //     { label: "Volunteer Name", key: "volunteer" },
        //     { label: "Organization Name", key: "org" },
        //     { label: "Role", key: "role" },
        //     { label: "Service Duration", key: "duration" },
        //     { label: "Supervisor Name", key: "supervisor" }
        //   ],
        //   prompt: `
        // Confirm that {{volunteer}} completed community service at {{org}} as a {{role}} for {{duration}}. Confirmed by {{supervisor}}.
        //   `
        // }

        // {
        //   title: "Proof of Address Affidavit",
        //   fields: [
        //     { label: "Full Name", key: "name" },
        //     { label: "ID Number", key: "idNumber" },
        //     { label: "Address", key: "address" },
        //     { label: "Date", key: "date" }
        //   ],
        //   prompt: `
        // Create a ${this.countryContext} affidavit by {{name}} (ID: {{idNumber}}) confirming residential address: {{address}}. Dated: {{date}}.
        //   `
        // }

        // {
        //   title: "Home Affairs Invitation Letter",
        //   fields: [
        //     { label: "Inviter's Full Name", key: "inviter" },
        //     { label: "Invitee's Full Name", key: "invitee" },
        //     { label: "Visit Reason", key: "reason" },
        //     { label: "Visit Dates", key: "dates" },
        //     { label: "Address of Stay", key: "stayAddress" }
        //   ],
        //   prompt: `
        // Generate a ${this.countryContext} Home Affairs invitation letter from {{inviter}} to {{invitee}}, for {{reason}}, staying at {{stayAddress}} from {{dates}}.
        //   `
        // }

        //legal
        acknowledgement_of_debt: [
          { label: "Debtor Full Name", key: "debtorName" },
          { label: "Debtor ID Number", key: "debtorId" },
          { label: "Creditor Full Name", key: "creditorName" },
          { label: "Creditor ID Number", key: "creditorId" },
          { label: "Amount Owed", key: "amount" },
          { label: "Repayment Terms", key: "terms" },
          { label: "Due Date", key: "dueDate" },
          { label: "Interest Rate (%)", key: "interestRate" },
          { label: "Governing Law", key: "governingLaw" },
        ],
        general_affidavit: [
          { label: "Full Name", key: "name" },
          { label: "ID Number", key: "id" },
          { label: "Residential Address", key: "address" },
          { label: "Statement of Facts", key: "statement" },
          { label: "Date", key: "date" },
          { label: "Commissioner of Oaths Name", key: "commissioner" },
        ],
        general_power_of_attorney: [
          { label: "Principal Full Name", key: "principalName" },
          { label: "Principal ID", key: "principalId" },
          { label: "Agent Full Name", key: "agentName" },
          { label: "Agent ID", key: "agentId" },
          { label: "Powers Granted", key: "powers" },
          { label: "Start Date", key: "startDate" },
          { label: "End Date", key: "endDate" },
          { label: "Jurisdiction", key: "jurisdiction" },
        ],
        vehicle_sale_power_of_attorney: [
          { label: "Principal Name", key: "principalName" },
          { label: "Agent Name", key: "agentName" },
          { label: "Vehicle Make & Model", key: "vehicleDetails" },
          { label: "Vehicle Registration Number", key: "regNumber" },
          { label: "VIN", key: "vin" },
          { label: "Start Date", key: "startDate" },
          { label: "End Date", key: "endDate" },
        ],
        loan_agreement: [
          { label: "Lender Name", key: "lenderName" },
          { label: "Borrower Name", key: "borrowerName" },
          { label: "Loan Amount", key: "amount" },
          { label: "Interest Rate (%)", key: "interestRate" },
          { label: "Repayment Terms", key: "repaymentTerms" },
          { label: "Start Date", key: "startDate" },
          { label: "Default Clause", key: "defaultClause" },
        ],
        residential_lease_agreement: [
          { label: "Landlord Name", key: "landlordName" },
          { label: "Tenant Name", key: "tenantName" },
          { label: "Property Address", key: "propertyAddress" },
          { label: "Lease Start Date", key: "startDate" },
          { label: "Lease End Date", key: "endDate" },
          { label: "Monthly Rent (R)", key: "monthlyRent" },
          { label: "Deposit (R)", key: "deposit" },
          { label: "Notice Period", key: "noticePeriod" },
        ],
        commercial_lease_agreement: [
          { label: "Landlord Name", key: "landlordName" },
          { label: "Tenant Name", key: "tenantName" },
          { label: "Business Name", key: "businessName" },
          { label: "Property Description", key: "propertyDescription" },
          { label: "Rental Amount (R)", key: "rentalAmount" },
          { label: "Lease Start Date", key: "startDate" },
          { label: "Lease End Date", key: "endDate" },
          { label: "Utilities Included", key: "utilities" },
          { label: "Maintenance Responsibility", key: "maintenance" },
        ],
        employment_contract_basic: [
          { label: "Employer Name", key: "employerName" },
          { label: "Employee Name", key: "employeeName" },
          { label: "Job Title", key: "jobTitle" },
          { label: "Start Date", key: "startDate" },
          { label: "Work Hours", key: "workHours" },
          { label: "Salary", key: "salary" },
          { label: "Leave Days", key: "leaveDays" },
          { label: "Notice Period", key: "noticePeriod" },
        ],
        resignation_letter: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Job Title", key: "jobTitle" },
          { label: "Employer Name", key: "employerName" },
          { label: "Date of Letter", key: "date" },
          { label: "Last Working Day", key: "lastDay" },
          { label: "Reason for Leaving", key: "reason" },
          { label: "Gratitude Statement", key: "gratitude" },
        ],
        notice_to_vacate: [
          { label: "Tenant Name", key: "tenantName" },
          { label: "Landlord Name", key: "landlordName" },
          { label: "Property Address", key: "propertyAddress" },
          { label: "Notice Date", key: "noticeDate" },
          { label: "Vacate Date", key: "vacateDate" },
          { label: "Reason", key: "reason" },
          { label: "Forwarding Address", key: "forwardingAddress" },
        ],
        cease_and_desist_letter: [
          { label: "Sender Name", key: "senderName" },
          { label: "Recipient Name", key: "recipientName" },
          { label: "Infringement Description", key: "infringement" },
          { label: "Demand", key: "demand" },
          { label: "Legal Consequences", key: "consequences" },
          { label: "Date", key: "date" },
        ],
        nda_agreement: [
          { label: "Disclosing Party", key: "discloser" },
          { label: "Receiving Party", key: "recipient" },
          { label: "Confidential Info Description", key: "confidentialInfo" },
          { label: "Obligations of Receiving Party", key: "obligations" },
          { label: "Duration of Confidentiality", key: "duration" },
          { label: "Jurisdiction", key: "jurisdiction" },
          { label: "Effective Date", key: "date" },
        ],
        sale_of_goods_agreement: [
          { label: "Seller Name", key: "sellerName" },
          { label: "Buyer Name", key: "buyerName" },
          { label: "Goods Description", key: "goodsDescription" },
          { label: "Quantity", key: "quantity" },
          { label: "Price per Unit", key: "pricePerUnit" },
          { label: "Total Price", key: "totalPrice" },
          { label: "Delivery Terms", key: "deliveryTerms" },
          { label: "Payment Terms", key: "paymentTerms" },
        ],
        service_agreement: [
          { label: "Service Provider Name", key: "providerName" },
          { label: "Client Name", key: "clientName" },
          { label: "Services Description", key: "services" },
          { label: "Start Date", key: "startDate" },
          { label: "End Date", key: "endDate" },
          { label: "Fees", key: "fees" },
          { label: "Payment Schedule", key: "paymentSchedule" },
          { label: "Termination Clause", key: "terminationClause" },
        ],
        complaint_letter_to_landlord: [
          { label: "Tenant Name", key: "tenantName" },
          { label: "Landlord Name", key: "landlordName" },
          { label: "Property Address", key: "propertyAddress" },
          { label: "Issue Description", key: "issue" },
          { label: "Requested Action", key: "action" },
          { label: "Date of Complaint", key: "complaintDate" },
          { label: "Response Deadline", key: "responseDeadline" },
        ],
        //Old fields
        sworn_affidavit_for_SASSA: [
          { label: "Applicant Name", key: "applicantName" },
          { label: "ID Number", key: "idNumber" },
          { label: "Reason for Affidavit", key: "reason" },
          { label: "Application Type", key: "grantType" },
        ],
        affidavit_for_lost_id: [
          { label: "Full Name", key: "name" },
          { label: "ID Number", key: "id" },
          { label: "Circumstances of Loss", key: "details" },
          { label: "Date of Loss", key: "lossDate" },
        ],
        notice_of_disciplinary_hearing: [
          { label: "Employee Name", key: "employee" },
          { label: "Employer Name", key: "employer" },
          { label: "Hearing Date", key: "hearingDate" },
          { label: "Allegation", key: "allegation" },
          { label: "Location", key: "location" },
        ],
        cohabitation_agreement: [
          { label: "Partner 1 Name", key: "partner1" },
          { label: "Partner 2 Name", key: "partner2" },
          { label: "Shared Address", key: "address" },
          { label: "Financial Terms", key: "financialTerms" },
          { label: "Effective Date", key: "date" },
        ],
        medical_fitness_certificate: [
          { label: "Patient Name", key: "patient" },
          { label: "Doctor Name", key: "doctor" },
          { label: "Diagnosis Summary", key: "diagnosis" },
          { label: "Fit For", key: "fitFor" },
          { label: "Certificate Date", key: "date" },
        ],
        lease_cancellation_letter: [
          { label: "Tenant Name", key: "tenantName" },
          { label: "Landlord Name", key: "landlordName" },
          { label: "Property Address", key: "address" },
          { label: "Effective Cancellation Date", key: "cancelDate" },
          { label: "Reason", key: "reason" },
        ],
        proof_of_employment_letter: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Position", key: "position" },
          { label: "Employment Start Date", key: "startDate" },
          { label: "Company Name", key: "company" },
          { label: "Monthly Salary", key: "salary" },
        ],
        internship_confirmation_letter: [
          { label: "Company Name", key: "company" },
          { label: "Intern Name", key: "intern" },
          { label: "Department", key: "department" },
          { label: "Start Date", key: "startDate" },
          { label: "End Date", key: "endDate" },
          { label: "Intern Role", key: "role" },
        ],
        employment_reference_letter: [
          { label: "Employer Name", key: "employerName" },
          { label: "Employee Name", key: "employeeName" },
          { label: "Position Held", key: "position" },
          { label: "Employment Duration", key: "duration" },
          { label: "Performance Summary", key: "performance" },
        ],
        business_plan: [
          { label: "Business Name", key: "businessName" },
          { label: "Owner Name", key: "ownerName" },
          { label: "Business Sector", key: "sector" },
          { label: "Business Goals", key: "goals" },
          { label: "Products/Services", key: "products" },
          { label: "Target Market", key: "market" },
          { label: "Financial Summary", key: "financeSummary" },
        ],
        letter_of_good_standing: [
          { label: "Company Name", key: "company" },
          { label: "Requestor Name", key: "name" },
          { label: "ID or Reg Number", key: "idNumber" },
          { label: "Reason", key: "reason" },
        ],
        travel_consent_for_minor: [
          { label: "Parent Name", key: "parent" },
          { label: "Child Name", key: "child" },
          { label: "Destination", key: "destination" },
          { label: "Travel Dates", key: "dates" },
          { label: "Accompanying Person", key: "accompanying" },
        ],
        stokvel_membership_agreement: [
          { label: "Member Name", key: "member" },
          { label: "Stokvel Name", key: "stokvel" },
          { label: "Contribution Amount", key: "amount" },
          { label: "Contribution Frequency", key: "frequency" },
          { label: "Agreement Date", key: "date" },
        ],
        acknowledgement_of_debt_one: [
          { label: "Debtor Name", key: "debtor" },
          { label: "Creditor Name", key: "creditor" },
          { label: "Amount Owed", key: "amount" },
          { label: "Payment Terms", key: "terms" },
          { label: "Agreement Date", key: "date" },
        ],
        educational_tutor_agreement: [
          { label: "Tutor Name", key: "tutor" },
          { label: "Student Name", key: "student" },
          { label: "Subject", key: "subject" },
          { label: "Session Frequency", key: "frequency" },
          { label: "Hourly Rate", key: "rate" },
        ],
        vehicle_sale_agreement: [
          { label: "Seller Name", key: "sellerName" },
          { label: "Buyer Name", key: "buyerName" },
          { label: "Vehicle Details", key: "vehicleDetails" },
          { label: "Registration Number", key: "registrationNumber" },
          { label: "Sale Price", key: "salePrice" },
          { label: "Date of Sale", key: "saleDate" },
        ],
        freelance_contract: [
          { key: "client", label: "Client Name" },
          { key: "projectDescription", label: "Project Description" },
          { label: "Freelancer Name", key: "freelancer" },
          { label: "Service Description", key: "services" },
          { label: "Project Amount", key: "fee" },
          { label: "Completion Deadline", key: "deadline" },
        ],
        invoice: [
          { key: "clientName", label: "Client Name" },
          { key: "services", label: "Services Rendered" },
          { key: "total", label: "Total Amount" },
          { key: "dueDate", label: "Due Date" },
        ],
        late_payment: [
          { key: "clientName", label: "Client Name" },
          { key: "invoiceNumber", label: "Invoice Number" },
          { key: "amountDue", label: "Amount Due" },
          { key: "dueDate", label: "Original Due Date" },
        ],
        debt_collection: [
          { key: "debtorName", label: "Debtor Name" },
          { key: "amount", label: "Amount Owed" },
          { key: "serviceDescription", label: "Service/Product Description" },
        ],
        nda: [
          { label: "Disclosing Party", key: "discloser" },
          { label: "Receiving Party", key: "receiver" },
          { key: "scope", label: "Confidentiality Scope" },
          { label: "Purpose of NDA", key: "purpose" },
          { label: "Effective Date", key: "effectiveDate" },
          { label: "Duration (in months)", key: "duration" },
        ],
        contract: [
          { key: "partyA", label: "Party A Name" },
          { key: "partyB", label: "Party B Name" },
          { key: "agreementDetails", label: "Agreement Details" },
        ],
        partnership: [
          { key: "partnerOne", label: "Partner One" },
          { key: "partnerTwo", label: "Partner Two" },
          { key: "businessDetails", label: "Business Purpose" },
        ],
        lease: [
          { key: "tenant", label: "Tenant Name" },
          { key: "landlord", label: "Landlord Name" },
          { key: "propertyAddress", label: "Property Address" },
          { key: "leaseAmount", label: "Monthly Rent" },
        ],
        resignation: [
          { key: "employeeName", label: "Employee Name" },
          { key: "employerName", label: "Employer Name" },
          { key: "lastDay", label: "Last Working Day" },
        ],
        employment: [
          { key: "employeeName", label: "Employee Name" },
          { key: "jobTitle", label: "Job Title" },
          { key: "salary", label: "Salary" },
        ],
        termination: [
          { key: "employeeName", label: "Employee Name" },
          { key: "terminationDate", label: "Termination Date" },
          { key: "reason", label: "Reason for Termination" },
        ],
        leave: [
          { key: "employeeName", label: "Employee Name" },
          { key: "leaveType", label: "Type of Leave" },
          { key: "dates", label: "Leave Dates" },
        ],
        warning: [
          { key: "employeeName", label: "Employee Name" },
          { key: "issue", label: "Issue Description" },
          { key: "warningDate", label: "Date of Warning" },
        ],
        consent: [
          { key: "patientName", label: "Patient Name" },
          { key: "guardianName", label: "Guardian (if any)" },
          { key: "procedure", label: "Procedure Description" },
        ],
        referral: [
          { key: "patientName", label: "Patient Name" },
          { key: "doctorName", label: "Referring Doctor" },
          { key: "reason", label: "Reason for Referral" },
        ],
        proof: [
          { key: "patientName", label: "Patient Name" },
          { key: "visitDate", label: "Consultation Date" },
          { key: "doctorName", label: "Doctor’s Name" },
        ],
        demand: [
          { key: "debtorName", label: "Debtor Name" },
          { key: "amount", label: "Amount Owed" },
          { key: "deadline", label: "Deadline Date" },
        ],
        affidavit: [
          { key: "fullName", label: "Your Full Name" },
          { key: "statement", label: "Affidavit Statement" },
        ],
        bill_of_costs: [
          { key: "clientName", label: "Client Name" },
          { key: "caseNumber", label: "Case Number" },
          { key: "charges", label: "Breakdown of Charges" },
        ],
        cv_and_cover_letter_on_same_pdf_separated_by_page_break: [
          { key: "fullName", label: "Full Name" },
          {
            key: "highestQualification",
            label:
              "Highest Qualification / Matric / Certificates / Diplomas / Degrees Achieved",
          },
          { key: "industry", label: "Industry Interested In" },
          { key: "experience", label: "Experience Summary" },
          { key: "skills", label: "Key Skills" },
          {
            key: "education",
            label: "Education / Schools / Trainings Attended",
          },
          { key: "reference", label: "References" },
          { key: "projects", label: "Projects / Internships / Volunteer Jobs" },
        ],
        cv_and_cover_letter_on_same_pdf_separated_by_page_break_normal: [
          { key: "fullName", label: "Full Name" },
          {
            key: "highestQualification",
            label:
              "Highest Qualification / Matric / Certificates / Diplomas / Degrees Achieved",
          },
          { key: "industry", label: "Industry Interested In" },
          { key: "experience", label: "Experience Summary" },
          { key: "skills", label: "Key Skills" },
          {
            key: "education",
            label: "Education / Schools / Trainings Attended",
          },
          { key: "reference", label: "References" },
          { key: "projects", label: "Projects / Internships / Volunteer Jobs" },
        ],
        cv_and_cover_letter_on_same_pdf_separated_by_page_break_student: [
          { key: "fullName", label: "Full Name" },
          {
            key: "highestQualification",
            label:
              "Highest Qualification / Matric / Certificates / Diplomas / Degrees Achieved",
          },
          { key: "industry", label: "Industry Interested In" },
          { key: "experience", label: "Experience Summary" },
          { key: "skills", label: "Key Skills" },
          {
            key: "education",
            label: "Education / Schools / Trainings Attended",
          },
          { key: "reference", label: "References" },
          { key: "projects", label: "Projects / Internships / Volunteer Jobs" },
        ],
        cv_and_cover_letter_on_same_pdf_separated_by_page_break_executive: [
          { key: "fullName", label: "Full Name" },
          {
            key: "highestQualification",
            label:
              "Highest Qualification / Matric / Certificates / Diplomas / Degrees Achieved",
          },
          { key: "industry", label: "Industry Interested In" },
          { key: "experience", label: "Experience Summary" },
          { key: "skills", label: "Key Skills" },
          {
            key: "education",
            label: "Education / Schools / Trainings Attended",
          },
          { key: "reference", label: "References" },
          { key: "projects", label: "Projects / Internships / Volunteer Jobs" },
        ],
        loan: [
          { key: "borrowerName", label: "Borrower Name" },
          { key: "lenderName", label: "Lender Name" },
          { key: "amount", label: "Loan Amount" },
          { key: "repaymentTerms", label: "Repayment Terms" },
        ],
        power_of_attorney: [
          { key: "grantor", label: "Grantor Name" },
          { key: "agent", label: "Agent Name" },
          { key: "scope", label: "Authority Scope" },
          { label: "Principal Name", key: "principalName" },
          { label: "ID Number", key: "idNumber" },
          { label: "Appointee Name", key: "appointeeName" },
          { label: "Purpose of Authority", key: "authorityPurpose" },
          { label: "Effective Date", key: "effectiveDate" },
        ],
        lesson_plan: [
          { key: "subject", label: "Subject" },
          { key: "grade", label: "Grade" },
          { key: "theme", label: "Theme/Topic" },
          { key: "outcomes", label: "Learning Outcomes" },
          { key: "assessment", label: "Assessment Methods" },
          { key: "date", label: "Date of Lesson" },
        ],
        school_transfer_letter: [
          { label: "Parent Full Name", key: "parentName" },
          { label: "Learner Full Name", key: "learnerName" },
          { label: "Current School", key: "currentSchool" },
          { label: "New School", key: "newSchool" },
          { label: "Reason for Transfer", key: "transferReason" },
        ],

        // Tender
        tender_cover_letter: [
          { label: "Company Name", key: "companyName" },
          { label: "Project Title", key: "projectTitle" },
          { label: "Reference Number", key: "referenceNumber" },
          { label: "Submission Date", key: "submissionDate" },
        ],
        tender_bid_proposal: [
          { label: "Company Name", key: "companyName" },
          { label: "Project Title", key: "projectTitle" },
          { label: "Reference Number", key: "referenceNumber" },
        ],
        company_profile_tender: [
          { label: "Company Name", key: "companyName" },
          { label: "Industry Type", key: "industryType" },
        ],
        declaration_of_interest: [
          { label: "Company Name", key: "companyName" },
          { label: "Reference Number", key: "referenceNumber" },
        ],
        bank_letter_tender: [
          { label: "Company Name", key: "companyName" },
          { label: "Project Title", key: "projectTitle" },
        ],
        subcontractor_agreement: [
          { label: "Main Contractor Name", key: "mainContractor" },
          { label: "Subcontractor Name", key: "subcontractor" },
          { label: "Project Title", key: "projectTitle" },
        ],
        nda_tender: [
          { label: "Company Name", key: "companyName" },
          { label: "Partner Name", key: "partnerName" },
          { label: "Project Title", key: "projectTitle" },
        ],

        // Construction and Quantity Surveying
        bill_of_quantities: [
          { label: "Project Name", key: "projectName" },
          { label: "Company Name", key: "companyName" },
        ],
        site_inspection_report: [
          { label: "Project Name", key: "projectName" },
          { label: "Inspection Date", key: "inspectionDate" },
          { label: "Inspector Name", key: "inspectorName" },
        ],
        variation_order_request: [
          { label: "Project Name", key: "projectName" },
        ],
        project_completion_certificate: [
          { label: "Project Name", key: "projectName" },
          { label: "Completion Date", key: "completionDate" },
          { label: "Consultant Name", key: "consultantName" },
        ],
        contractor_performance_report: [
          { label: "Contractor Name", key: "contractorName" },
          { label: "Project Name", key: "projectName" },
        ],
        progress_payment_certificate: [
          { label: "Contractor Name", key: "contractorName" },
          { label: "Project Name", key: "projectName" },
          { label: "Valuation Date", key: "valuationDate" },
        ],
        construction_contract_agreement: [
          { label: "Client Name", key: "clientName" },
          { label: "Contractor Name", key: "contractorName" },
          { label: "Project Name", key: "projectName" },
        ],

        // Insurance Company
        insurance_quote_letter: [
          { label: "Client Name", key: "clientName" },
          { label: "Policy Type", key: "policyType" },
          { label: "Premium Amount", key: "premiumAmount" },
          { label: "Coverage Period", key: "coveragePeriod" },
        ],
        policy_schedule: [{ label: "Client Name", key: "clientName" }],
        claim_form: [
          { label: "Client Name", key: "clientName" },
          { label: "Policy Number", key: "policyNumber" },
          { label: "Incident Date", key: "incidentDate" },
          { label: "Incident Details", key: "incidentDetails" },
        ],
        accident_report: [
          { label: "Client Name", key: "clientName" },
          { label: "Incident Date", key: "incidentDate" },
        ],
        policy_cancellation_letter: [
          { label: "Client Name", key: "clientName" },
          { label: "Policy Number", key: "policyNumber" },
          { label: "Cancellation Date", key: "cancelDate" },
        ],
        renewal_notice: [
          { label: "Client Name", key: "clientName" },
          { label: "Policy Number", key: "policyNumber" },
          { label: "Renewal Date", key: "renewalDate" },
        ],
        insurance_cover_confirmation: [
          { label: "Client Name", key: "clientName" },
          { label: "Policy Number", key: "policyNumber" },
          { label: "Start Date", key: "startDate" },
          { label: "End Date", key: "endDate" },
        ],

        // Immigration and Visa Applicants
        proof_of_employment_letter: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Employer Name", key: "employerName" },
          { label: "Start Date", key: "startDate" },
          { label: "Salary", key: "salary" },
          { label: "Position", key: "position" },
        ],
        invitation_letter_for_visa: [
          { label: "Host Name", key: "hostName" },
          { label: "Host Address", key: "hostAddress" },
          { label: "Visitor Name", key: "visitorName" },
          { label: "Country", key: "country" },
          { label: "Start Date", key: "startDate" },
          { label: "End Date", key: "endDate" },
        ],
        bank_statement_summary: [
          { label: "Account Holder", key: "accountHolder" },
          { label: "Start Date", key: "startDate" },
          { label: "End Date", key: "endDate" },
        ],
        affidavit_of_support: [
          { label: "Sponsor Name", key: "sponsorName" },
          { label: "Applicant Name", key: "applicantName" },
          { label: "Country", key: "country" },
        ],
        cover_letter_for_visa: [
          { label: "Applicant Name", key: "applicantName" },
        ],
        travel_itinerary_visa: [
          { label: "Applicant Name", key: "applicantName" },
          { label: "Departure Date", key: "departureDate" },
          { label: "Return Date", key: "returnDate" },
        ],
        proof_of_accommodation: [
          { label: "Applicant Name", key: "applicantName" },
          { label: "Hotel Name or Address", key: "hotelNameOrAddress" },
          { label: "Check-In", key: "checkIn" },
          { label: "Check-Out", key: "checkOut" },
        ],

        // Payslip
        monthly_payslip: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Month", key: "month" },
          { label: "Year", key: "year" },
        ],
        bonus_payslip: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Bonus Date", key: "bonusDate" },
        ],
        termination_payslip: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Termination Date", key: "terminationDate" },
        ],
        overtime_payslip: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Overtime Hours", key: "overtimeHours" },
          { label: "Overtime Rate", key: "overtimeRate" },
        ],
        salary_advance_slip: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Advance Amount", key: "advanceAmount" },
          { label: "Advance Date", key: "advanceDate" },
        ],
        commission_payslip: [
          { label: "Employee Name", key: "employeeName" },
          { label: "Period", key: "period" },
          { label: "Total Sales", key: "totalSales" },
          { label: "Commission Amount", key: "commissionAmount" },
        ],
      };
      return fields;
      //return fields[this.selectedDocType] || [];
    },
    isFormValid() {
      return Object.values(this.docData).every((v) => !!v);
    },
    getSelectedDocKey() {
      return this.$store.getters.getSelectedDocKey;
    },
  },
  data() {
    return {
      otp: "",
      editor: null,
      loaderMessage: "Fetching Data...",
      loggedIn: false,
      company: JSON.parse(localStorage.getItem("userCompany")) || null,
      docGenerated: false,
      singlePricePlan: { title: "Single Download Plan", price: 99 },
      selectedDocObj: null,
      priceCategories: {
        tier1: {
          title: "Single Download Plan",
          price: 69,
        },
        tier2: {
          title: "Single Download Plan",
          price: 69,
        },
        tier3: {
          title: "Single Download Plan",
          price: 99,
        },
        tier4: {
          title: "Single Download Plan",
          price: 199,
        },
        tier5: {
          title: "Single Download Plan",
          price: 299,
        },
      },
      pricingPlans: {
        single: {
          title: "Basic Plan",
          price: 69,
          features: ["7 Generations", "Valid for 7 Days"],
        },
        monthly: {
          title: "Standard Plan",
          price: 369,
          features: ["107 Generations", "Valid for 31 Days"],
        },
        year: {
          title: "Premium Plan",
          price: 1369,
          features: ["1077 Generations", "Valid for 365 Days"],
        },
      },
      currencyConversionRate: null,
      countryContext: localStorage.getItem("countryContext") || null,
      getCurrency: localStorage.getItem("currency") || null,
      timezone: localStorage.getItem("timezone") || null,
      regionName: localStorage.getItem("regionName") || null,
      docsAiLogObj: JSON.parse(localStorage.getItem("docsAiLogObj")) || null,
      currentStep: 1,
      selectedDocTemplateUrl: null,
      selectedDocTemplatePrompt: null,
      selectedDocType: null,
      extraSpecificRequirement: "",
      selectedTier: "single",
      docData: {},
      pdfContent: "",
      pdfBlobUrl: "",
      chatGPTKey:
        "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",
      showPaymentModal: false,

      //email
      emailDialog: false,
      emailSubject: "",
      emailRecipient: "",
      emailRecipients: [],
      emailBody: "",

      loading: false,
      loadingPaypal: false,
      loadingPayfast: false,
      formValid: false,
      selectedDocumentCategory: { text: "Everyday Documents", value: "common" },
      documentsCategories: [
        { text: "Everyday Documents", value: "common" },
        { text: "Legal Documents", value: "legal" },
        { text: "Tender Documents", value: "tender" },
        { text: "Construction & Surveying Documents", value: "construction" },
        { text: "Insurance Documents", value: "insurance" },
        { text: "Travel & Immigration Documents", value: "travel" },
        { text: "Employment & HR Documents", value: "hr" },
      ],
      selectedLanguage: "English",
      languages: [
        "Afrikaans",
        "Amharic",
        "Arabic",
        "Bengali",
        "Bulgarian",
        "Burmese",
        "Chinese (Simplified)",
        "Chinese (Traditional)",
        "Croatian",
        "Czech",
        "Danish",
        "Dutch",
        "English",
        "Filipino (Tagalog)",
        "Finnish",
        "French",
        "German",
        "Greek",
        "Gujarati",
        "Hebrew",
        "Hindi",
        "Hungarian",
        "Indonesian",
        "Italian",
        "Japanese",
        "Khmer",
        "Korean",
        "Lao",
        "Malay",
        "Malayalam",
        "Marathi",
        "Nepali",
        "Norwegian",
        "Persian (Farsi)",
        "Polish",
        "Portuguese",
        "Punjabi",
        "Romanian",
        "Russian",
        "Serbian",
        "Slovak",
        "Spanish",
        "Swahili",
        "Swedish",
        "Tamil",
        "Telugu",
        "Thai",
        "Turkish",
        "Ukrainian",
        "Urdu",
        "Vietnamese",
        "Zulu",
      ],
      documentTypes: [],
      brand: {
        name: "",
        logoUrl: "",
        logoFile: null,
        logoBase64: "",
        address: "",
        phone: "",
      },
      showVerificationDialog: false,

      //cluade pdf gen
      pdfDataUrl: null,
      loading: false,
      pdfDoc: null,
      totalPages: 0,
      currentPage: 1,
      zoom: 1.0,
      pdfReady: false,
      pdfBlob: null,
      generatedPdfDataUrl: null,

      //chatgpt
      systemPrompt: `You are an expert document writer, legal assistant and a professional document specialist in legal, business, medical, educational, tender, and insurance documents.
      You write highly detailed, formal, and professionally structured documents of all types
       — including CVs, cover letters, affidavits, contracts, business plans, and proposals — based on minimal user input.

      You Always expand and elaborate generously, using long, well-organized paragraphs and structured formatting.
       Your goal is to make the documents comprehensive, verbose, and valuable.
-For professional documents (CVs, contracts, plans), You include standard sections such as:
   - CV: Name, Contact Info, Summary, Skills, Experience, Education, Certifications, Projects, References
   - Contract: Parties, Definitions, Terms, Termination, Dispute Resolution, Signatures
   - Business Plan: Executive Summary, Market Analysis, Strategy, Financials, Risks, Appendices

   You Elaborate deeply with real-world phrasing, strong paragraphs, and professional depth.
   You Use executive tone, and persuasive formatting.
- You Output only valid pdfMake document definition JSON. No markdown, no explanation, no text outside the JSON

When the user requests a document, recognize the type and generate an output that:
- Is long and complete, not a summary.
- Follows the tone, format, and structure expected for that type (e.g., legal, business, personal).
- Includes all conventional sections for that document type.
- Uses realistic and professional content, even if the user input is brief.

If the user provides a template, You reuse it exactly and only replace placeholders with rich content.
`,
    };
  },
  async created() {
    const data = await companyJs.getSiteInfo(this.getCompanyEmis, this);
  },
  async updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  async mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    this.getAndLoadSelectedDocCategory();

    this.$store.commit("setLoader", true);
    await this.registerIPAndGetCountryContext();
    this.$store.commit("setLoader", false);

    if (this.notLoggedIn()) {
      this.forceToLogIn();
    }

    if (this.loggedInButNotVerified()) {
      this.showVerificationDialog = true;
    }

    if (this.getPDFContent) {
      this.currentStep = 3;
      this.regeneratePDFAfterPay(this.getPDFContent);
    }
  },
  methods: {
    verifyUserEmail() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/verify-user-email-address",
          { email: this.getCurrentUser.email, code: this.otp },
          this.getAccessToken
        )
        .then((currentUser) => {
          this.$store.commit("setCurrentUser", currentUser);
          localStorage.setItem("currentUser", JSON.stringify(currentUser));
          this.showVerificationDialog = false;
          this.$store.commit("setLoader", false);
        });
    },
    notLoggedIn() {
      if (!this.getAuthenticated) {
        return true;
      } else {
        return false;
      }
    },
    forceToLogIn() {
      setTimeout(() => {
        // First run after 90 seconds
        this.$router.push({ path: "/login" });
      }, 90 * 1000);
    },
    loggedInButNotVerified() {
      if (this.getCurrentUser.id && !this.getCurrentUser.email_verified_at) {
        return true;
      } else {
        return false;
      }
    },
    createNewDoc() {
      this.$store.commit("setLoader", true);
      localStorage.clear();
      window.location.reload();
      this.$store.commit("setLoader", false);
    },
    getAndLoadSelectedDocCategory() {
      const arr = [...this.allDocsTypes[this.selectedDocumentCategory.value]];
      this.documentTypes = arr;
    },
    removeWatermark() {
      this.showPaymentModal = true;
    },
    async getAndConvertCurrency() {
      if (this.getCurrency != "ZAR") {
        const currencyConversionRate =
          await helpersJs.getCurrencyConversionRateFromFrankfurterApi(
            "ZAR",
            this.getCurrency
          );
        if (currencyConversionRate) {
          this.currencyConversionRate = currencyConversionRate;
          const plans = Object.values(this.pricingPlans);
          plans.forEach((plan) => {
            plan.price = helpersJs.convertCurrencyFrankfurterApi(
              parseFloat(plan.price) + 25,
              currencyConversionRate
            );
          });
          this.pricingPlans = plans;
        }
      }
    },
    async registerIPAndGetCountryContext(docGenerated = null) {
      const data = await axios.postDataWithToken(
        "/get-docs-ai-data",
        {},
        this.getAccessToken
      );

      if (data && data.ipData) {
        this.docsAiLogObj = data.log;
        this.$store.commit("setDocsAiLogObj", data.log);
        //force to log in
        if (
          data.log &&
          data.log.subscription != "guest" &&
          data.log.subscription != "single" &&
          !this.isLimitExceeded &&
          !this.getAuthenticated
        ) {
          this.$router.push({ path: "/login" });
        }
        //data.ipData.countryCode: "ZA"
        this.$store.commit("setUserIP", data.ipData.ip);
        this.countryContext = data.ipData.countryName;
        this.getCurrency = data.ipData.currencyCode;
        this.$store.commit("setCurrency", data.ipData.currencyCode);
        this.timezone = data.ipData.timezone;
        this.regionName = data.ipData.regionName;

        this.company = data.company;
        this.$store.commit("setUserCompany", data.company);

        localStorage.setItem("countryContext", data.ipData.countryName);
        localStorage.setItem("getCurrency", data.ipData.currencyCode);
        localStorage.setItem("timezone", data.ipData.timezone);
        localStorage.setItem("regionName", data.ipData.regionName);

        localStorage.setItem("userCompany", JSON.stringify(data.company));
        localStorage.setItem("currency", data.ipData.currencyCode);
        localStorage.setItem("appName", data.company.name);
      }
    },
    async docGeneratedRegisterLogAndGetLog() {
      const logAndData = await axios.postDataWithToken(
        "/doc-generated",
        {
          docObj: this.selectedDocObj,
        },
        this.getAccessToken
      );

      this.docsAiLogObj = logAndData.log;
      this.$store.commit("setDocsAiLogObj", logAndData.log);
    },

    getSelectedDocTemplateUrl() {
      const docObj = this.documentTypes.find((docType) => {
        return docType.key == this.selectedDocType;
      });
      this.$store.commit("setSelectedDocKey", this.selectedDocType);
      this.selectedDocObj = docObj;

      if (docObj) {
        this.singlePricePlan = this.priceCategories[docObj.priceTier];

        if (docObj && docObj.templateUrl) {
          this.selectedDocTemplateUrl = docObj.templateUrl;
        } else {
          this.selectedDocTemplateUrl = null;
        }

        if (docObj && docObj.prompt) {
          this.selectedDocTemplatePrompt = docObj.prompt;
        } else {
          this.selectedDocTemplatePrompt = null;
        }
        if (this.currentStep == 1) {
          this.currentStep = 2;
        }
      }
    },
    handleLogoUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.brand.logoBase64 = e.target.result;
      };
      if (file) {
        reader.readAsDataURL(file);
      }
    },

    async generateDocument() {
      //if (!this.$refs.form.validate()) return;

      if (this.isLimitExceeded) {
        this.$toast.warning("You’ve reached your document limit!.");
      }

      this.loaderMessage = "Generating PDF...";
      this.preGeneratePDF();
      this.$store.commit("setCounterLoader", true);
      this.loading = true;
      const prompt = this.buildPrompt(this.selectedDocType, this.docData);
      let systemPrompt = null;
      if (this.selectedDocObj && this.selectedDocObj.systemPrompt) {
        systemPrompt = this.selectedDocObj.systemPrompt;
      }
      try {
        const response = await this.generateWithChatGPT(prompt, systemPrompt);

        // Sanitize if necessary: remove code block syntax, etc.
        const result = response
          .trim()
          .replace(/^```(json)?/, "")
          .replace(/```$/, "");

        this.pdfContent = JSON.parse(result);

        this.generatePDF();
        await this.docGeneratedRegisterLogAndGetLog();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
        this.$store.commit("setCounterLoader", false);
      }
    },
    regeneratePDFAfterPay(result) {
      this.selectedDocType = this.getSelectedDocKey;
      this.getSelectedDocTemplateUrl();
      this.currentStep = 3;
      this.pdfContent = JSON.parse(result);

      this.generatePDF();
    },
    preGeneratePDF() {
      const docDefinition = {
        content: ["", "Generating document..."],
      };

      docDefinition.content.unshift({
        canvas: [{ type: "line", x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 1 }],
      });
      docDefinition.content.unshift({ text: "\n" });
      docDefinition.content.unshift({
        columns: [
          this.brand.logoBase64 || this.brand.logoUrl
            ? {
                image: this.brand.logoBase64 || this.brand.logoUrl,
                width: 100,
              }
            : "",
          [
            { text: this.brand.name, style: "MyHeader" },
            { text: this.brand.address, style: "MySubheader" },
            { text: this.brand.phone, style: "MySubheader" },
          ],
        ],
        margin: [0, 0, 0, 10],
      });

      if (!docDefinition.styles) {
        docDefinition.styles = {
          MyHeader: {
            fontSize: 16,
            bold: true,
            color: this.getThemeColor,
          },
          MySubheader: {
            fontSize: 13,
            color: this.getThemeColor,
          },
        };
      } else {
        docDefinition.styles.Myheader = {
          fontSize: 16,
          bold: true,
          color: this.getThemeColor,
        };

        docDefinition.styles.MySubheader = {
          fontSize: 13,
          color: this.getThemeColor,
        };
      }

      if (!this.getPaymentDone) {
        docDefinition.watermark = {
          text: "Docs-Ai.co.za PDF!",
          color: "red",
          opacity: 0.3,
          bold: true,
          italics: false,
        };
      }

      if (this.isMobile) {
        //Cluade method for mobile rendering
        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          this.pdfBlob = blob;

          const reader = new FileReader();
          reader.onload = async () => {
            const typedArray = new Uint8Array(reader.result);

            const pdf = await pdfjsLib.getDocument({ data: typedArray })
              .promise;
            this.pdfDoc = pdf;
            this.totalPages = pdf.numPages;
            this.pdfReady = true;
            this.renderPage();
            this.loading = false;
          };
          reader.readAsArrayBuffer(blob);
        });
      } else {
        // this.pdfContent Insert AI-generated content here
        const pdfDoc = pdfMake.createPdf(docDefinition);
        pdfDoc.getBlob((blob) => {
          this.pdfBlobUrl = URL.createObjectURL(blob);
        });
      }
    },
    generatePDF() {
      const docDefinition = this.pdfContent;

      //include if branding is set if branding is set
      if (this.brand.name) {
        docDefinition.content.unshift({
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 1 },
          ],
        });
        docDefinition.content.unshift({ text: "\n" });
        docDefinition.content.unshift({
          columns: [
            this.brand.logoBase64 || this.brand.logoUrl
              ? {
                  image: this.brand.logoBase64 || this.brand.logoUrl,
                  width: 100,
                }
              : "",
            [
              { text: this.brand.name, style: "MyHeader" },
              { text: this.brand.address, style: "MySubheader" },
              { text: this.brand.phone, style: "MySubheader" },
            ],
          ],
          margin: [0, 0, 0, 10],
        });
        if (!docDefinition.styles) {
          docDefinition.styles = {
            MyHeader: {
              fontSize: 16,
              bold: true,
              color: this.getThemeColor,
            },
            MySubheader: {
              fontSize: 13,
              color: this.getThemeColor,
            },
          };
        } else {
          docDefinition.styles.Myheader = {
            fontSize: 16,
            bold: true,
            color: this.getThemeColor,
          };

          docDefinition.styles.MySubheader = {
            fontSize: 13,
            color: this.getThemeColor,
          };
        }
      }

      if (!this.getAuthenticated || !this.getPaymentDone) {
        docDefinition.watermark = {
          text: "Docs-Ai.co.za PDF!",
          color: "red",
          opacity: 0.3,
          bold: true,
          italics: false,
        };
      }
      this.$store.commit("setPDFContent", JSON.stringify(docDefinition));
      if (this.isMobile) {
        //Cluade method for mobile rendering
        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          this.pdfBlob = blob;

          const reader = new FileReader();
          reader.onload = async () => {
            const typedArray = new Uint8Array(reader.result);

            const pdf = await pdfjsLib.getDocument({ data: typedArray })
              .promise;
            this.pdfDoc = pdf;
            this.totalPages = pdf.numPages;
            this.pdfReady = true;
            this.renderPage();
            this.loading = false;
          };
          reader.readAsArrayBuffer(blob);
        });
      } else {
        // this.pdfContent Insert AI-generated content here
        const pdfDoc = pdfMake.createPdf(docDefinition);
        pdfDoc.getBlob((blob) => {
          this.pdfBlobUrl = URL.createObjectURL(blob);
        });
      }
    },
    buildPrompt(type, data) {
      const title = type.replace(/_/g, " ");
      let intro = `You are an expert document generation assistant trained in layout, legal drafting, and professional content creation.
      Your task is to generate a rich, legally accurate, visually structured "${title}" using pdfMake.

### USER INPUT:
The user has provided the following data fields:\n`;

      for (const key in data) {
        intro += `- ${key}: ${data[key]}\n`;
      }

      if (this.selectedDocTemplateUrl) {
        intro += `\nUse the external template from: ${this.selectedDocTemplateUrl}
This is the official reference template for layout, styling, spacing, section structure, headers, tables, and visual formatting.
Match the visual design *EXACTLY* as per this PDF template.\n`;
      }

      if (this.selectedDocTemplatePrompt) {
        intro += `\nDesign Notes:\n${this.selectedDocTemplatePrompt}\n`;
      }

      if (this.getCurrency) {
        intro += `
All monetary values must use the currency "${this.getCurrency}" and follow local formatting standards for ${this.regionName}, ${this.countryContext}.
Timezone: ${this.timezone}
`;
      }

      if (this.extraSpecificRequirement) {
        intro += `\nUser-specific requirements:\n${this.extraSpecificRequirement}\n`;
      }

      // 🔥 Strong instructional enforcement
      intro += `
## HARD RULES:
- Use full paragraphs, detailed examples, formal language, and real-world phrasing.
executive-style paragraph, combining education, skills, and industry focus to position the user strongly.
- If the document is legally binding, **use region-specific legal language for ${this.countryContext} / ${this.regionName}**.
- If a **non-English language** is selected, all **visible text content** must be translated into **"${this.selectedLanguage}"**.
   - Keep pdfMake formatting (keys like 'text', 'table', etc.) in English.

## OUTPUT RULES:
- .
- No placeholders or example names. Use only what is provided — if missing, skip the field.
- Spell check and ensure correct professional tone.

## BONUS INSTRUCTION:
- If there is not enough user data, creatively and professionally extrapolate from the available information
— expand summaries, describe roles, offer useful context or assumptions **without inventing false data**.

### Your response must be:
- Fully formed
- Visually clean
- Professionally styled
- Only valid pdfMake JSON
`;

      return intro;
    },
    //     buildPrompt(type, data) {
    //       let intro = `You are an expert document layout and PDF generation assistant.
    // You are also a skilled frontend developer and a professional document specialist in legal, business, medical, educational, tender, and insurance sectors.
    // Your role is to generate a well-structured, visually accurate, legally and regionally compliant, and content-rich "${type.replace(
    //         /_/g,
    //         " "
    //       )}".

    // Here is the data provided for this document:\n`;

    //       for (const key in data) {
    //         intro += `- ${key}: ${data[key]}\n`;
    //       }

    //       if (this.selectedDocTemplateUrl) {
    //         intro += `
    // Use the following country-specific reference template to match the visual structure, formatting, and layout EXACTLY:
    // Template: ${this.selectedDocTemplateUrl}
    // Region: ${this.regionName}
    // Country: ${this.countryContext}

    // Match every visual aspect of the template precisely:
    // - Page structure, alignment, spacing, fonts
    // - Table borders, styles, colors, margins
    // - Section headings and ordering
    // - Signature lines, footers, headers, and standard formatting
    // `;
    //       }

    //       if (this.selectedDocTemplatePrompt) {
    //         intro += `\nAdditional Template Notes: ${this.selectedDocTemplatePrompt}`;
    //       }

    //       if (this.getCurrency) {
    //         intro += `
    // If the document requires monetary amounts, use the currency "${this.getCurrency}" consistently.
    // Use "${this.regionName}" formatting standards for currency and dates.
    // Timezone for all time references should be: ${this.timezone}.
    // Ensure the formatting reflects local conventions in ${this.countryContext}.
    // `;
    //       }

    //       if (this.extraSpecificRequirement) {
    //         intro += `\nAdditional Requirements:\n${this.extraSpecificRequirement}\n`;
    //       }

    //       intro += `
    // For CVs:
    // -Professional Summary should be expanded to half a page summary of the usual objectives of the selected industry. use the education, industry and skills to provide content for the Professional Summary.
    // Strict Instructions:

    // - Ensure the document is rich, content-heavy, and fills AT LEAST TWO (2) FULL PAGES.
    // - Expand each section with detailed content. Use real-world phrasing, or elaborations to provide substance.
    // - For structured documents (e.g., CVs, business plans, contracts), include all expected and professional sections relevant to that document type.
    // - Use appropriate legal phrasing and format for documents that have legal implications, following the legal norms of ${this.regionName}, ${this.countryContext}.
    // - If the language selected is not English, write all content in "${this.selectedLanguage}", but keep pdfMake formatting syntax in English.

    // Output Format Instructions:
    // - Respond ONLY with a clean, complete, and valid pdfMake document definition object (JSON format).
    // - DO NOT include code blocks, markdown, or explanations.
    // - OMIT any field not provided in the input data. Do not use placeholders or sample values.
    // - Use bullet points, tables, clear section headings, and subheadings as appropriate.
    // - Use page breaks only as needed — Do not include page break labels in the prompt content.
    // - Check for spelling accuracy and compliance with regional language norms.

    // Special Document Logic:
    // - For invoices and quotations, compute and display:
    //   - Subtotal: Total of all items before discount and VAT.
    //   - Discount: Subtract from subtotal if applicable.
    //   - VAT: Add on top of discounted amount if applicable.
    //   - Total: Final amount after all calculations.
    // - Ensure VAT and currency formatting are correct per ${this.countryContext} standards.

    // FINAL RULES:
    // - Your ONLY response must be a valid pdfMake-compatible JSON document definition.
    // - Do NOT include explanations, extra text, or markdown.
    // - Focus on visual accuracy, legal correctness, and detailed, multi-page content that directly renders via pdfMake.`;

    //       return intro;
    //     },
    //     buildPrompt(type, data) {
    //       let intro = `You are an expert document layout and PDF generation assistant,
    //       An expert frontend developer and also a legal, business, medical, educational, tender and insurance documents expert.
    //       Generate a detailed, well structured, well formatted, well outlined, professional "${type.replace(
    //         /_/g,
    //         " "
    //       )}" based on:\n`;
    //       for (const key in data) {
    //         intro += `- ${key}: ${data[key]}\n`;
    //       }
    //       if (this.selectedDocTemplateUrl) {
    //         intro += `Your task is to return a valid pdfMake document definition that visually and structurally matches the following
    //         ${this.countryContext} ${type.replace(/_/g, " ")} template exactly: ${
    //           this.selectedDocTemplateUrl
    //         }`;
    //         intro += `Match the visual structure and layout exactly: margins, fonts, alignment, spacing, borders, table format, colors etc.`;
    //       }

    //       if (this.selectedDocTemplatePrompt) {
    //         intro += this.selectedDocTemplatePrompt;
    //       }

    //       if (this.getCurrency) {
    //         intro += `if currency is needed in the creation of this document, use ${this.getCurrency} for it. example, for fees, for prices, for amounts etc. all monies should use ${this.getCurrency}`;
    //         intro += `use ${this.timezone} as the time zone for all time related aspect of the document generation`;
    //         intro += `use ${this.regionName} as the specific local region or province for specificity in the appropriate document template to be used in the document generation.
    //         Use this to format dates and currency properly`;
    //       }

    //       if (this.extraSpecificRequirement) {
    //         intro += this.extraSpecificRequirement;
    //       }

    //       intro += `\nRespond ONLY with formatted text suitable for pdfMake, including sections, bullet points, and clear headings. Do not include markdown or code.`;
    //       //intro += `\nRespond ONLY with formatted text suitable for pdfMake. No markdown or code.`;
    //       intro += `\n As an expert in generating professional documents, check and make sure that all spellings are correct, and that the format used in the document is the current accepted format in the above named country.`;

    //       intro += `The Content of the Document must be produced in its entirety in the ${this.selectedLanguage} language whiles markup for pdfmake content definition remains in English to help pdfmake render the content as a pdf.`;
    //       intro += `Avoid any sign or symbols that may cause pdfmake to not render. example **Page 1 - . you are an expert frontend developer. Ensure that when the language is not English, you format it in such a way that, it can still render a pdfmake PDF `;
    //       intro += `The goal is to render the returned document definition directly in pdfmake. so make sure even if the language is not English, it can still render. so FOCUS on the correctness of the document definition for pdfmake especially in all languages `;
    //       intro += `Page Break is only used to indicate that whatever follows it must go to the next page. Do Not include page break from the prompt in the content.`;

    //       intro += `
    //                 Strict Instructions:
    //                 Use the pdfMake document definition format only.
    //                 Do not include any fields that are missing from the user input.
    //                 for invoices and quotations, Perform calculations for:
    //                 Subtotal (sum of all item amounts before discounts and tax)
    //                 Discount (if provided, subtract before VAT)
    //                 VAT (if provided, apply after discount, and display clearly)
    //                 Total.

    //                 Respect provided dynamic fields:
    //                 Do not include example or placeholder values — only use the data passed in.

    //                 Use clean, maintainable pdfMake syntax.
    //                 Return only a valid JSON object representing the pdfMake document definition.
    //                 Do not explain, describe, or preface the output.
    // Do not wrap the object in markdown or code blocks.
    // Only include user-provided fields. Omit missing ones completely.
    // Dynamic fields you may receive:
    // Do not output explanations, markdown, or text outside the pdfMake document definition.`;
    //       return intro;
    //     },

    async generateWithChatGPT(prompt, systemPrompt = null) {
      if (systemPrompt) {
        this.systemPrompt = systemPrompt + this.systemPrompt;
      }
      const response = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.chatGPTKey}`,
          },
          body: JSON.stringify({
            model: "gpt-4",
            messages: [
              { role: "system", content: this.systemPrompt },
              { role: "user", content: prompt },
            ],
            temperature: 0.4,
          }),
        }
      );

      const json = await response.json();
      return (
        (json.choices &&
          json.choices[0] &&
          json.choices[0].message &&
          json.choices[0].message.content) ||
        "Failed to generate document"
      );

      //return json.choices[0]?.message?.content || "Failed to generate document";
    },
    renderPage() {
      if (!this.pdfDoc) return;

      this.pdfDoc.getPage(this.currentPage).then((page) => {
        const viewport = page.getViewport({ scale: this.zoom });
        const canvas = this.$refs.pdfCanvas;
        const context = canvas.getContext("2d");

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext: context,
          viewport: viewport,
        };

        page.render(renderContext);
      });
    },
    downloadPDF() {
      if (!this.isMobile) {
        this.downloadPdfDesktop();
        return;
      }
      if (this.pdfBlob) {
        const url = URL.createObjectURL(this.pdfBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "document.pdf";
        a.click();
        URL.revokeObjectURL(url);
      }
    },
    downloadPdfDesktop() {
      pdfMake
        .createPdf(this.pdfContent)
        .download(`${this.selectedDocType}.pdf`);
      // pdfMake
      //   .createPdf({ content: [{ text: this.pdfContent }] })
      //   .download(`${this.selectedDocType}.pdf`);
    },
    openEmailDialog() {
      this.emailRecipients = [];
      this.emailDialog = true;
      this.$nextTick(() => {
        if (this.getEmailBodyHtml) {
          this.editor.render(JSON.parse(this.getEmailBodyHtml));
        } else {
          this.renderEditorJs();
        }
      });
    },
    closeDialog() {
      this.emailDialog = false;
      this.showPaymentModal = false;
    },
    // Extract only the text parts from docDefinition
    extractVisibleText(content) {
      return content
        .filter(
          (block) => typeof block.text === "string" || Array.isArray(block.text)
        )
        .map((block) =>
          Array.isArray(block.text)
            ? block.text.map((t) => t.text || t).join("")
            : block.text
        )
        .join("\n\n");
    },

    async generateEmailBody() {
      this.loaderMessage = "Generating Email Content...";
      this.$store.commit("setLoader", true);
      const dd = JSON.parse(this.getPDFContent);
      const prompt = `You are a professional administrative secretary.
      Write a professional email for the subject "${
        this.emailSubject
      }" addressed to "${this.emailRecipient}",
      based on this text content : ${this.extractVisibleText(dd.content)}.
      Check and correct all spelling mistakes, and ensure the tone is formal and professional.
      Provide the email content formatted strictly as valid Editor.js JSON data (following Editor.js block structure), including types like "paragraph", "header", "list", or "code" blocks as needed.
      Do NOT include any explanations, comments, or code blocks outside the JSON. Output ONLY the JSON object, so it can be directly used as input to EditorJS's render method: this.editor.render(chatGPTApiData);
      `;
      try {
        let response = await this.generateWithChatGPT(prompt);

        // Sanitize if necessary: remove code block syntax, etc.
        response = response
          .trim()
          .replace(/^```(json)?/, "")
          .replace(/```$/, "");

        this.$store.commit("setEmailBodyHtml", response);
        this.editor.render(JSON.parse(response));
        await this.docGeneratedRegisterLogAndGetLog();
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.commit("setLoader", false);
      }
    },
    async sendEmail() {
      this.$store.commit("setLoader", true);
      const savedData = await this.editor.save();

      const parser = new Parser(); // default options
      const html = parser.parse(savedData, "markdown");

      const pdfDoc = pdfMake.createPdf(JSON.parse(this.getPDFContent));
      pdfDoc.getBase64((base64) => {
        // Prepend proper data URI scheme for PDF
        this.generatedPdfDataUrl = `data:application/pdf;base64,${base64}`;
        this.$store.commit("setLoader", false);
        this.sendToLaravel(html); // or whatever method sends the payload via Axios
      });
    },
    sendToLaravel(html) {
      if (!this.emailRecipients || this.emailRecipients.length < 1) {
        this.$toast.error("Atleast 1 Recipient Email is Required!");
        return false;
      }

      this.$store.commit("setLoader", true);
      const pdfDataUrlBase64 = this.generatedPdfDataUrl;

      if (!Array.isArray(this.emailRecipients)) {
        this.emailRecipients = helpersJs.splitStringToArray(
          this.emailRecipients
        );
      }

      const payload = {
        markdownBody: html,
        pdfDataUrlBase64: pdfDataUrlBase64,
        recipients: this.emailRecipients,
        recipient: this.emailRecipient,
        subject: this.emailSubject,
      };
      const response = axios.postData("/send-doc-as-attachment", payload);
      this.$toast.success("Email Sent Successfully!");
      this.$store.commit("setLoader", false);
      this.closeDialog();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.renderPage();
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.renderPage();
      }
    },

    zoomIn() {
      if (this.zoom < 2) {
        this.zoom += 0.1;
        this.renderPage();
      }
    },

    zoomOut() {
      if (this.zoom > 0.5) {
        this.zoom -= 0.1;
        this.renderPage();
      }
    },
    async signedOut() {
      await this.registerIPAndGetCountryContext();
    },
    renderEditorJs() {
      this.editor = new EditorJS({
        holder: "editorjs",
        placeholder: "",
        tools: {
          header: Header,
          list: List,
          table: Table,
          code: CodeTool,
          paragraph: {
            class: Paragraph,
            inlineToolbar: true,
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.pdf-canvas-wrapper {
  overflow-x: auto;
  padding: 5px;
}

.pdf-canvas {
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  height: auto;
}

.cards {
  max-width: 400px;
  width: 95%;
  background-color: #e3ddec;
}

.name {
  font-size: 1.125rem;
}

button {
  color: #aea2c6;
  border: 2px solid #160e25;
}

.img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 15px;
  border: 5px solid rgba(219, 201, 3, 0.964);
}

.card-box:hover {
  transform: translateY(-12px) scale(1.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}
</style>
